import APITemplate from '@api/APITemplate'
import store from '@state/store'
import { valorDaPropostaParaOCartao } from '@modules/aawz-intelligence-v2/api/valor-do-cartao-de-proposta'
import con from '@services/connection'
import { GlobalBus } from '@services/bus'
import { CREDITOS, RELOAD } from '@constants/Text'
import {
  iaCrmRequest,
  ehAborto,
  foiCancelado,
  respostaDeCancelamento,
  isStreamResponse,
  getLineFromBuffer,
} from '@modules/aawz-intelligence-v2/utils/api'
import { intelligenceV2 } from '@modules/aawz-intelligence-v2/constants/URL'
// ★ O mapa `evento SSE → handler` mora em `chat-event-handlers.js` desde o
// redesign imersivo: este arquivo já passava do teto de linhas do repo, e
// registrar evento novo aqui dentro o empurrava mais. `STORE_PRINCIPAL` vem
// junto porque é o mesmo fato (o namespace onde serviços citados e painel
// vivem, mesmo quando a instância tem namespace próprio) — duas cópias dele
// divergiriam.
import {
  getEventHandlers,
  STORE_PRINCIPAL as STORE,
} from '@modules/aawz-intelligence-v2/api/chat-event-handlers'
// RF-G2 — acumulação dos agentes do turno (fan-out do Supervisor), extraída
// pelo mesmo motivo do import acima (ver cabeçalho de `agentes-do-turno.js`).
import {
  entradaDeAgentSelected,
  acumularAgente,
  agentesIniciaisDoStart,
  payloadDeComitarAgente,
} from '@modules/aawz-intelligence-v2/api/agentes-do-turno'
import { TOOL_PART_STATE } from '@modules/aawz-intelligence-v2/store/toolParts'
import { ESTADO_DO_NO } from '@modules/aawz-intelligence-v2/constants/NosDoSupervisor'
import { fontesWebDoTurno } from '@modules/aawz-intelligence-v2/utils/fontes-web-do-turno'
import { FASE_INICIAL, faseAposEvento } from '@modules/aawz-intelligence-v2/utils/fase-do-turno'
import { contextoSemTela, normalizarFiltros, normalizarRota } from '@modules/aawz-intelligence-v2/utils/contexto-de-tela'
import { contextoDeExecucaoVazio } from '@modules/aawz-intelligence-v2/utils/contexto-de-execucao'
import { planoTerminado } from '@modules/aawz-intelligence-v2/utils/plano-do-turno'
import { resolverEntrada } from '@modules/aawz-intelligence-v2/ui-registry'
import {
  chaveDaToolDeFront,
  uiDaAcaoDeFront,
  EXECUTOR_CLIENTE,
} from '@modules/aawz-intelligence-v2/ui-registry/chave-de-tool-de-front'
import { registrarExecutorDeAcao } from '@modules/aawz-intelligence-v2/ui-registry/execucao'
// [spec-017 T003] Os DOIS caminhos de CONTINUAÇÃO de turno que vivem nesta
// classe (`sendToolOutput`, `reenviarUltimoTurno`) — nenhum deles é chamado
// por `view-chat.vue`, então a decisão sobre o Modo de Voz (ADR-017-01: a
// régua é `motorDeVoz.sessaoDeVozAtiva` lida NO MOMENTO da ação) precisa ser
// tomada AQUI DENTRO. Import seguro: `motor-de-voz.js` não importa `apiChat`
// em nenhum ponto da própria cadeia (`estado-da-voz`/`vad-de-voz`/
// `fala-da-ia`/`captura-de-voz`/`sons-de-voz` — verificado).
// [spec-008 T030b] A cadeia CRESCEU: `motor-de-voz.js` passou a importar
// `transporte-tempo-real.js` (é o import que liga o registro no seletor) e,
// por ele, os oito irmãos do transporte + `api/apiVoz.js`. Reverificado:
// `apiVoz` só importa `APITemplate`/`guardas`/`URL`/`connection`, e nenhum
// arquivo da família `transporte-*` cita `apiChat` — segue sem ciclo.
import {
  motorDeVoz,
  iniciarFalaProgressiva,
  finalizarFalaProgressiva,
  processarEventoFala,
} from '@modules/aawz-intelligence-v2/utils/motor-de-voz'
// [spec-019 T004-delta] A MESMA régua que decide o texto da bolha de erro
// (`chat-message.vue::textoDoErroDoTurno`, [G-4] do design it.2) — sem ela,
// a tela filtrava o traceback e a voz o lia cru em voz alta.
import { copyDoErroDoTurno } from '@modules/aawz-intelligence-v2/utils/copy-do-erro-do-turno'
// ★ merge PR #2242 — os DOIS mixins do Modo Agente (spec-002) continuam
// aplicados no fim do arquivo. `apiChatStream`/`apiChatPainel` NÃO: os
// métodos deles colidem com 11 e 7 desta classe, e um `Object.assign` os
// sobrescreveria em silêncio com a versão anterior às specs de
// `desenvolvimento` (medido no merge: `_processEvent`, `_consumeStreamBuffer`,
// `_flushTokenBuffer`, `_maybeCapturePendingConfirmation`, entre outros).
import { normalizarEnvelopeDeEvento } from '@modules/aawz-intelligence-v2/api/sseParser'
import { apiChatModoAgenteMixin } from '@modules/aawz-intelligence-v2/api/apiChatModoAgente'
import { apiChatModoAgenteEventosMixin } from '@modules/aawz-intelligence-v2/api/apiChatModoAgenteEventos'
import { anexosParaOCorpo } from '@modules/aawz-intelligence-v2/utils/anexos-para-o-corpo'

const STREAM_HEADER = { Accept: 'text/event-stream' }

// ★ merge PR #2242 — o `error` do relay agêntico chega com `seq` FIXO (=1),
// que não é cursor: ver `_descartarFrameRepetido`.
/**
 * O `value` que o cartão `crm/confirmacao` espera, a partir do evento do fio.
 *
 * Espelha `ui-crm-confirmacao.schema.json` (`required`: `requer_confirmacao`,
 * `resumo`, `entidade`, `operacao`, `entidade_label`, `operacao_label`). Os
 * rótulos humanos vivem no `preview` do evento; o resto, no topo.
 *
 * Devolve `null` quando não há material — evento fora do contrato não vira
 * payload meia-boca, vira ausência (e o renderer segue com a régua dele).
 *
 * **O defeito que isto corrige** (medido em produção, 18/09/2026, run
 * `d3abf662`, escritório 83): o evento traz os campos no TOPO e no `preview`
 * — nunca em `value`, e sem `ui`. O renderizador lê `propsDaParte`, que só
 * conhece `ui.props` ou `value`: sem um dos dois a parte não tem o que
 * desenhar, e o consultor via **"Não consegui montar este cartão"** enquanto
 * a run ficava parada em `awaiting_approval` — segurando a reserva de
 * créditos, porque o botão que aprova mora no cartão que não desenhou.
 *
 * ⚠️ **Nada aqui é inventado.** Cada campo vem do evento; `requer_confirmacao`
 * é o único derivado, e por definição — o evento É um pedido de aprovação.
 */
const EVENTO_ISENTO_DO_DEDUPE = 'error'


/**
 * ★ DEDUP DO DUAL-EMIT (spec-001 do `project-plataforma-por-chat`).
 *
 * O backend emite o vocabulário ANTIGO e o NOVO para o MESMO fato — `token` e
 * `text-delta` carregam o mesmo pedaço de texto, `thinking` e `reasoning-delta`
 * o mesmo raciocínio (`core/sse.py`, mapa `dual_emit_map`). Processar os dois
 * escreveria cada palavra da resposta duas vezes na tela.
 *
 * Enquanto o dual durar, a FONTE é o evento antigo: ele é o que está em
 * produção nas quatro superfícies, com o buffer de `requestAnimationFrame` já
 * calibrado. O evento novo continua sendo RECONHECIDO (em vez de cair no ramo
 * "evento desconhecido") para que a escolha esteja escrita num lugar só — na
 * fase 1, quando o antigo sair do fio, basta trocar estas duas constantes.
 */
const FONTE_DE_TEXTO = 'token'
const FONTE_DE_RACIOCINIO = 'thinking'

// Estados que um evento SSE pode carimbar numa parte. A máquina que os governa
// (e o vocabulário completo) vive em `store/toolParts.js`; aqui ficam com o
// nome que o parser usa, sem redigitar a string.
const ESTADO_ENTRADA = TOOL_PART_STATE.ENTRADA
const ESTADO_APROVACAO = TOOL_PART_STATE.APROVACAO
const ESTADO_SAIDA = TOOL_PART_STATE.SAIDA
const ESTADO_ERRO_DE_TOOL = TOOL_PART_STATE.ERRO

/**
 * As tools que já têm registro PRÓPRIO no `tool_calls` da mensagem — a
 * transcrição do painel e os serviços citados são montados a partir dos canais
 * do turno, com a forma que `extrairPainel`/`extrairServicosCitados` esperam.
 * Repetir a parte crua ao lado criaria duas origens para o mesmo cartão.
 */
const TOOLS_COM_REGISTRO_PROPRIO = ['citar_servicos', 'convocar_painel']

/**
 * O status que o motor carimba num turno que morreu sem o servidor dizer qual
 * foi ([T024]). Só vale quando o evento `error` não trouxe `status`: o do
 * servidor sempre vence.
 */
const STATUS_ERRO_DO_TURNO = 500
/**
 * O turno RECUSADO por saldo de créditos esgotado — `status` no CORPO, HTTP 200
 * (`aawz_intelligence_v2/core/gate_creditos.py`). Chega de duas formas e cai
 * no MESMO desfecho (`_desfechoDeSaldoEsgotado`): no `end` do fio, com o texto
 * da recusa em `value.response` e `value.bloqueio` ao lado (o contrato do
 * gate), ou num envelope não-stream / evento `error` com `message`.
 */
const STATUS_SALDO_ESGOTADO = 402
// O `status` do CORPO decide — o HTTP é sempre 200 (contrato da casa).
const ehBloqueioPorSaldo = (data) => Boolean(data) && data.status === STATUS_SALDO_ESGOTADO
// `duracao_s` da mensagem sai com uma casa ("4,2s" na linha de raciocínio).
const DECIMO_DE_SEGUNDO_MS = 100
const DECIMOS_POR_SEGUNDO = 10

// ── A resposta ao cartão de confirmação ([spec-010 T018]) ───────────────────
//
// [feedback do usuário, 03/09] `MENSAGEM_CANCELAR` mudou de 'Cancelar' pra
// 'Descartar' — o rótulo do botão (`ia-confirm-action.vue`) virou "Descartar"
// no redesenho de hoje, e o histórico da conversa mostrava o usuário
// "dizendo" uma palavra diferente da que ele clicou (confuso: o balão do
// usuário lia "Cancelar" mesmo depois do botão já dizer "Descartar" há
// várias mudanças). Seguro trocar: o backend não faz match exato de string
// nessas mensagens (conferido em `core/sse.py`/`usecase_ia_crm_chat.py`,
// nenhum `== 'Cancelar'`) — é a LLM interpretando a frase, que entende
// "Descartar" tão bem quanto "Cancelar" no mesmo contexto de pergunta
// ("Posso confirmar a criação?"). `MENSAGEM_CONFIRMAR` ('Confirmo') não
// mudou — o botão continua "Confirmar", sem descompasso.
const ACAO_CONFIRMAR = 'confirmar'
const ACAO_CANCELAR = 'cancelar'
const MENSAGEM_CONFIRMAR = 'Confirmo'
const MENSAGEM_CANCELAR = 'Descartar'

// As duas falhas que o servidor NÃO explica (ele nem chegou a falar): a copy é
// nossa, e ela diz o que aconteceu e o que fazer — mensagem de erro sem saída é
// meia mensagem (§UX do CLAUDE.md).
const COPY_QUEDA_DE_CONEXAO = 'Erro de conexão'
const COPY_FALHA_DE_RECONEXAO = 'Erro de reconexão'
// ★ [G-2 do QA da spec-001] O fio que acaba SEM `end` e sem `error`. Não houve
// exceção e o servidor não disse nada — só parou de falar no meio. A copy diz
// o que dá para afirmar (a resposta não veio inteira) e o que fazer, porque
// mandar de novo é justamente o que o botão da bolha oferece.
const COPY_FECHO_ANOMALO =
  'A resposta foi interrompida antes de terminar. Tente enviar de novo.'

// [G-5 SHOULD, review spec-017, 10/09] A chave do CONTRATO NO FIO para o
// Modo de Voz — antes existia como literal `'modo_voz'` duplicado em
// `_buildChatBody` e `_payloadSendToolOutput`: dois conhecimentos
// independentes do mesmo contrato. Renomear/condicionar num dos dois não
// quebrava o outro, e o modo de falha é SILENCIOSO — a continuação de tool
// de front (`sendToolOutput`) voltaria a sair muda sem erro nenhum, o
// defeito que a T003 corrigiu e que ninguém tinha reportado em meses.
// `_campoModoVoz` é o ÚNICO lugar que sabe montar este campo.
const CHAVE_MODO_VOZ_NO_CORPO = 'modo_voz'

/** `{modo_voz: true}` quando `vozAtiva`, `{}` senão — nunca `modo_voz: false`. */
function _campoModoVoz(vozAtiva) {
  return vozAtiva ? { [CHAVE_MODO_VOZ_NO_CORPO]: true } : {}
}

/**
 * `{comando: {slug, argumento, id_cliente?}}` quando há atalho de verdade,
 * `{}` senão — [spec-001 preparacao-reuniao, T015, D8.1]. Extraído de
 * `_buildChatBody` para não estourar o teto de complexidade/statements do
 * repo (o método já reúne sete campos opcionais).
 *
 * O atalho de negócio (`/panorama`, `/pré-reunião <cliente>`) é a TERCEIRA
 * forma de entrada do turno, ao lado de `query`/`tool_output`
 * (`core/atalhos/preflight.py::comando_do_corpo`,
 * `contratos/entrada.py::ComandoDeAtalho`). Contrato: `{slug, argumento?,
 * id_cliente?}` — `extra='forbid'` no servidor, então NENHUM outro campo
 * pode entrar aqui (P1: tenant/papel/faceta saem sempre da sessão).
 */
function _campoComando(comando) {
  if (!comando || !comando.slug) return {}
  const campo = {
    slug: comando.slug,
    argumento: comando.argumento != null ? comando.argumento : null,
  }
  if (comando.id_cliente != null) campo.id_cliente = comando.id_cliente
  return { comando: campo }
}

// ★ [spec-008, 17/09/2026] A chave do CONTRATO NO FIO para o CLIQUE no cartão
// — o `toolCallId` da parte que estava esperando aprovação.
//
// Por que ela existe: `modo_voz` (acima) marca a SESSÃO, não a fala. Dentro do
// Modo de Voz, o clique em "Confirmar" manda `modo_voz: true` exatamente como
// um "Confirmo" DITO em voz alta, e o servidor recebia os dois
// indistinguíveis — com a guarda de origem ligada (`core/origem_do_turno`),
// quem passava a ser recusado era o CLIQUE, o consentimento mais forte que o
// desenho tem. O dado que os separa já existia aqui e era jogado fora:
// `responderConfirmacao` desestruturava `toolCallId` para fora do envio.
//
// O id é INFORJÁVEL por transcrição — fala nenhuma carrega id de cartão. É o
// mesmo princípio que torna o protocolo de confirmação do Fee Fixo (frase com
// uuid) seguro por construção, e o motivo de NÃO ser uma heurística sobre o
// texto: "Confirmo" falado e "Confirmo" clicado são o mesmo texto.
//
// O nome é contrato com o `reqparse` de `resource_chat.py` — renomear de um
// lado só desliga a guarda do clique em silêncio.
const CHAVE_TOOL_CALL_ID_DO_CARTAO_NO_CORPO = 'tool_call_id_do_cartao'

/**
 * `{tool_call_id_do_cartao: <id>}` quando o turno nasceu de um clique no
 * cartão, `{}` senão — nunca a chave com valor vazio.
 *
 * String vazia é o que `view-chat.vue::_payloadResponderCartao` produz quando
 * o evento chega sem `toolCallId` (`|| ''`): ausência de prova, não prova de
 * clique. Mandá-la faria o servidor tratar evento malformado como
 * consentimento forte.
 */
function _campoCliqueNoCartao(toolCallIdDoCartao) {
  return toolCallIdDoCartao
    ? { [CHAVE_TOOL_CALL_ID_DO_CARTAO_NO_CORPO]: toolCallIdDoCartao }
    : {}
}

// `contracts/events.json` → `tool-input-available.executor`. O do CLIENTE vem
// do arquivo que o parser e o renderer compartilham — os dois decidem coisas
// diferentes sobre o mesmo eixo, e duas cópias divergiriam em silêncio.
const EXECUTOR_PADRAO = 'server'

// O desfecho de uma tool que o guard recusou. Estado do contrato, terminal
// como os outros `output-*`.
const ESTADO_RECUSA = TOOL_PART_STATE.RECUSA

// `tools_de_front.py` → `MODOS`. `automatico` só quando o usuário PEDIU a ação;
// `oferecer` desenha o cartão e espera o clique. A regra vive na descrição da
// tool (é o modelo quem escolhe); aqui ela é APLICADA.
const MODO_AUTOMATICO = 'automatico'

// O que o modelo recebe quando a ação não pôde acontecer. `recusado` é o campo
// do contrato (`contracts/ui-components.md` §4); o `motivo` é o que ele explica
// ao usuário.
const montarRecusa = (motivo) => ({ recusado: true, motivo: motivo })

// Rotas do motor de chat. Toda superfície fala com a MESMA porta única
// (`intelligenceV2.chat`); uma instância com `endpoints` próprio (ex.: o
// Especialista Fee-Based) troca de NAMESPACE de store, não de rota.
//
// ★ [spec-010 T030] Até aqui existiam DUAS rotas dedicadas (Consultor
// Estratégico e Especialista Fee-Based) que fixavam persona/origem pelo
// próprio ENDPOINT — `_endpointDoChat` escolhia entre elas por `persona`.
// Removidas: as duas superfícies agora falam com a porta única e declaram
// `origem_modulo` no corpo (`_buildChatBody`).
//
// ⚠️ **Acoplamento operacional que este arquivo sozinho não resolve.** A rota
// genérica IGNORA o campo `persona` do corpo em QUALQUER estado da flag
// (`resource_chat.py::_resolver_persona`, [T018]) e cai no default (IA
// Operacional) sempre que `self._persona` governa o turno — o que só deixa
// de acontecer quando `IA_SUPERVISOR_ATIVO=true` e o Gateway entra por
// `_atender_via_supervisor` (`usecase_ia_crm_chat.py::atender`). Com a flag
// `false` (o default medido em 03/09/2026 — Wave 8/gate A1 ainda não fechou
// em homolog), o drawer do Fee Fixo e a aba do Consultor, falando com `/chat`,
// **respondem como o IA Operacional**, não como a persona especializada — é
// a MESMA regressão que o comentário desta constante alertava antes deste
// commit. Este PR não pode ir a um ambiente com a flag desligada sem essa
// consequência; a correção de runtime é ligar `IA_SUPERVISOR_ATIVO`, não
// código do front (ver STATE.md da spec-010, nota "T030 diferido p/
// release 2").
//
// ★ [06/09/2026] `agente_solicitado` NÃO é `persona` de volta pela porta dos
// fundos. É um eixo NOVO: o agente que o usuário ESCOLHEU explicitamente na
// sidebar/palette/composer (`view-chat.vue::irParaAgente`, único produtor),
// e só viaja na CRIAÇÃO da conversa (`_buildChatBody`, guard
// `!conversationId`) E quando o item escolhido É um agente do catálogo
// (`constants/Agentes.js::agentSlugRequisitavel` — nem todo item da sidebar
// é um agente roteável; ver o comentário dela). `persona`, acima, era o
// roteamento AUTOMÁTICO por ENDPOINT (morto desde [T030]) —
// `agente_solicitado` é um PEDIDO humano de "fale com o agente X", que passa
// por elegibilidade e pode ser recusado, nunca uma determinação. Contrato
// fechado com o dev de backend (`dev-agente-fixado-explicito`, 06/09/2026):
// o `reqparse` do `resource_chat.py` registra `agente_solicitado`
// (`EntradaDeTurno.agente_solicitado`), aceita no `/chat` genérico e RECUSA
// em rota com `PERSONA_FIXA` (mesma guarda de `_resolver_persona`) — o
// mecanismo server-side vive em `core/supervisor/nos_declaracao_explicita.py`
// (`TipoEventoRun.AGENTE_DECLARADO_PELO_USUARIO`), que também reconhece a
// declaração TEXTUAL ("quero falar com o comercial") como sinal irmão deste
// campo.
const ENDPOINTS_PADRAO = {
  chat: intelligenceV2.chat,
  chatStatus: intelligenceV2.chatStatus,
  chatReconnect: intelligenceV2.chatReconnect,
  chatCancel: intelligenceV2.chatCancel,
}

/**
 * [spec-013 T024] A marca de TIPO do `_ultimoEnvio`.
 *
 * O "Tentar de novo" da bolha de erro repete o ÚLTIMO envio desta instância —
 * e até aqui só `sendMessage` gravava um, então o reenvio de um `/panorama`
 * morto no meio mandava de volta o último TEXTO digitado: o consultor pedia um
 * panorama e recebia a pergunta anterior, que já tinha sido respondida. Envio
 * sem `tipo` é o de TEXTO (forma histórica, default); com esta marca, é um
 * atalho de negócio, e `reenviarUltimoTurno` o repete pelo transporte do
 * atalho (corpo com `comando`, nunca com `query`).
 */
const TIPO_ENVIO_ATALHO = 'atalho'

// `isStreamResponse` vive em `utils/api.js` (a porta de entrada do stream):
// um envelope JSON em HTTP 200 chega como objeto simples e é tratado por
// `_tratarRespostaNaoStream` — não é drenado como se fosse stream (US-3).

/**
 * Espelho do `_copiar_presentes` do backend (`core/sse.py:123`): chave ausente
 * no evento NÃO vira `undefined` na parte.
 *
 * `upsertToolPart` MESCLA os campos (`store/toolParts.js:123`), então mandar
 * `label: undefined` no evento de desfecho apagaria o rótulo que o esqueleto já
 * mostrava — o cartão perderia o nome no exato instante em que ganha o dado.
 */
function copiarPresentes(destino, origem, chaves) {
  for (const chave of chaves) {
    if (Object.prototype.hasOwnProperty.call(origem, chave)) {
      destino[chave] = origem[chave]
    }
  }
  return destino
}

/**
 * `toolCallId` ausente é legítimo no dual de abertura — o `tool_use_start` do
 * provider ainda não tem id (decisão T002, `contracts/events.json` →
 * `ToolCallId`). Parear por POSIÇÃO criaria uma parte órfã que desfecho nenhum
 * alcança: o esqueleto ficaria girando na tela para sempre.
 */
function temToolCallId(data) {
  return Boolean(data && data.toolCallId)
}

/**
 * spec-009 [T006] — o payload comum de `setClienteDaConversa` a partir do
 * evento `cliente-identificado` (`contracts/events.json`). Função de módulo
 * (não método) para manter a complexidade de `_onClienteIdentificado` sob o
 * teto do lint — a lógica em si não depende de `this`.
 */
function payloadClienteIdentificado(data, conversationId) {
  return {
    id_cliente_app: data.id_cliente_app,
    codigo: data.codigo || null,
    nome: data.nome || null,
    conversation_id: conversationId || null,
  }
}

/**
 * O guard do AC-2.3: `true` quando um cliente foi FIXADO MANUALMENTE nesta
 * MESMA conversa e é DIFERENTE do que o evento acabou de declarar. Divergir
 * na conversa (`fixado.conversation_id !== payload.conversation_id`) não
 * bloqueia nada — o fixado é de outra conversa, irrelevante aqui.
 */
function guardDeClienteFixado(fixado, payload) {
  if (!fixado || fixado.conversation_id !== payload.conversation_id) return false
  return Number(fixado.id_cliente_app) !== Number(payload.id_cliente_app)
}


function scheduleFrame(callback) {
  if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
    return window.requestAnimationFrame(callback)
  }
  return setTimeout(callback, 16)
}

function cancelFrame(handle) {
  if (handle === null || handle === undefined) return
  if (typeof window !== 'undefined' && typeof window.cancelAnimationFrame === 'function') {
    window.cancelAnimationFrame(handle)
    return
  }
  clearTimeout(handle)
}

/**
 * Cliente do pipeline de chat SSE do `aawz-intelligence-v2` — Modo Chat
 * (legado) e Modo Agente (spec-002-chat-agentico-estilo-claude-code).
 *
 * A classe fica pequena de propósito (`CLAUDE.md`: arquivos ≤ 500 linhas);
 * o corpo dela é composto por 3 mixins aplicados ao prototype no fim deste
 * arquivo — cada um documenta os PRÓPRIOS métodos:
 *   - `apiChatStream.js`   parser SSE incremental, buffer de tokens, fase do turno
 *   - `apiChatPainel.js`   canais legados: preview de write-tool, serviços
 *                          citados, perguntas ao gestor, painel deliberativo
 *   - `apiChatModoAgente.js` runs, propostas, cursor, reconexão por EOF
 *
 * Estado encapsulado por instância (uma instância singleton em produção, mas
 * cada teste pode criar a sua para evitar contaminação entre suítes):
 *   - `responseData`         última payload `end` recebida
 *   - `reconnectCalled`      flag para evitar loop de reconexão
 *   - `abortController`      controla o `fetch` SSE ativo
 *   - `activeReader`         `ReadableStreamDefaultReader` em uso
 *   - `_tokenBuffer`         tokens acumulados antes de despachar (rAF flush)
 *   - `_tokenFlushHandle`    handle do rAF/timer pendente
 *   - `_servicosCitados`     itens de `citar_servicos` do turno em andamento
 *   - `_perguntasAoGestor`   perguntas de `perguntar_ao_gestor` do turno em andamento
 *   - `_painel`              transcrição do painel do turno em andamento
 *   - `_painelSeqVisto`      maior `seq` de `painel_evento` já aplicado no turno
 *   - `_planoVersaoVista`    maior `versao` de `plano` já aplicada no turno
 *   - `_planoDoTurno`        último quadro de `plano` do turno em andamento (Modo Agente incluso) — persiste em `message.plano` se terminado
 *   - `_sseParser`           `SseLineParser` — estado do evento SSE em construção
 *   - `_runAtualIdRun`       `id_run` do Modo Agente (spec-002) acompanhado agora
 *   - `_runAtualSeq`         cursor (`seq`) do último GRUPO de frames aplicado
 *   - `_conversationIdAtual` conversa em curso — fallback do `reconectarPorCursor`
 *   - `_terminalRecebido`    true quando `end`/`error` já fechou o turno/run
 *   - `_reconexaoEofEmAndamento` guard de reentrância do laço de EOF (VERIFY-1/M-5)
 *   - `_ultimoFrameAplicado` `{seq, frameIndex}` do último frame aplicado — dedup de
 *                          replay parcial de grupo dual (VERIFY-1/C-78)
 */
class APIChat extends APITemplate {
  /**
   * @param {Object=} opts
   * @param {string=} opts.storeNamespace  Módulo Vuex que recebe os dispatches.
   *   Cada superfície de chat precisa do SEU: `conversation_id` e `messages`
   *   vivem no store, então compartilhar namespace faria a mensagem de um chat
   *   ser anexada à conversa aberta no outro.
   * @param {Object=} opts.endpoints  Rotas do motor (chat, status, reconnect,
   *   cancel). Um endpoint dedicado fixa a persona no backend.
   * @param {Function=} opts.contextoDeTela  Provedor da tela aberta (US-5) —
   *   `() => ({rota_atual, filtros_da_tela})`. Uma subclasse pode passá-lo aqui;
   *   a superfície que monta a view usa `setContextoDeTelaProvider` no
   *   `created()`. Ausente ⇒ a mensagem sai sem a tela, sem quebrar.
   */
  constructor({ storeNamespace, endpoints, contextoDeTela } = {}) {
    super()
    this.storeNamespace = storeNamespace || STORE
    this.endpoints = { ...ENDPOINTS_PADRAO, ...(endpoints || {}) }
    this._contextoDeTelaProvider = typeof contextoDeTela === 'function' ? contextoDeTela : null
    // Quem quer ver cada PEDAÇO de texto assim que ele chega, além do buffer
    // normal do store — hoje só o Modo de Voz (04/09), pra sintetizar frase a
    // frase em vez de esperar o `end` (`_onTextoDeltaProvider`,
    // `setOnTextoDelta`). [voz v3, 08/09] `_onEventoFalaProvider` é o mesmo
    // molde pra versão FALADA do turno (evento SSE `fala`, separada do texto
    // escrito), via `setOnEventoFala`. `Object.assign` — não duas
    // atribuições — pra não estourar o teto de statements do construtor.
    Object.assign(this, { _onTextoDeltaProvider: null, _onEventoFalaProvider: null })
    // Quem sabe qual é o router/store da superfície (US-4). Registrado pela
    // view no `created()`, pelo mesmo molde do contexto de tela — e por um
    // motivo mais forte: `import router from '@router'` aqui fecha o ciclo que
    // derrubou 8 suítes em 26/08 (ver `utils/contexto-de-execucao.js`).
    this._contextoDeExecucaoProvider = null
    // O cartão da ação oferecida vive no thread e, no clique, precisa devolver
    // o `tool_output` por ESTA instância — não pelo singleton do chat do CRM.
    // O índice é por namespace (`ui-registry/execucao.js`).
    registrarExecutorDeAcao(this.storeNamespace, this)
    // O último envio do USUÁRIO por esta instância — é o que o "Tentar de novo"
    // da bolha de erro reenvia. Fora do `_resetarEstadoDaInstancia` de
    // propósito: ele roda no começo de cada `sendMessage`, e zerar aqui apagaria
    // justamente o envio que acabou de falhar. [spec-013 T024]
    // `_despachanteDeAtalho` é quem sabe repetir um envio de ATALHO (registrado
    // por `registrarEnvioDeAtalho`, ver lá o porquê de não ser um import).
    // `Object.assign` — não duas atribuições — pelo teto de statements do
    // construtor, mesma razão do `Object.assign` acima.
    Object.assign(this, { _ultimoEnvio: null, _despachanteDeAtalho: null })
    this._iniciarControleDeStream()
    this._tokenBuffer = []
    this._tokenFlushHandle = null
    // Fase do turno (spec-007 R1) — derivada dos eventos no `_processEvent`.
    // Fora do `_resetarEstadoDaInstancia` porque ele também roda no meio do
    // turno de tool de front, e ali a fase tem de sobreviver.
    this._faseDoTurno = FASE_INICIAL
    // Os buffers do TURNO nascem pelo mesmo helper que o `resetChatState` usa —
    // uma instância nova e um turno novo têm exatamente o mesmo estado inicial,
    // e mantê-los em dois lugares é como eles divergem. Os quatro que o
    // redesign imersivo inicializava aqui (`_servicosCitados`,
    // `_perguntasAoGestor`, `_painel`, `_painelSeqVisto`) já moram lá dentro.
    this._resetarEstadoDaInstancia()
    // Modo Agente (spec-002/D13) — o run acompanhado por ESTA instância.
    this._inicializarEstadoDoAgente()
  }

  /**
   * ★ merge PR #2242 — estado do Modo Agente (spec-002) que os mixins
   * `apiChatModoAgente`/`apiChatModoAgenteEventos` leem e escrevem. Vivia no
   * construtor da versão da branch; aqui é método próprio pelo mesmo motivo do
   * `_resetarEstadoDaInstancia` (o teto de statements do construtor).
   *
   * Sem estes seis campos os mixins rodam sobre `undefined`: o cursor de
   * reidratação nunca avança, o guard de reentrância do EOF não guarda nada e
   * o dedup de frame deixa passar replay — tudo em silêncio, porque ler
   * propriedade inexistente em JS não é erro.
   */
  _inicializarEstadoDoAgente() {
    this._runAtualIdRun = null
    this._runAtualSeq = 0
    this._conversationIdAtual = null
    this._terminalRecebido = false
    // [VERIFY-1/M-5] Guard de reentrância do laço de reconexão por EOF — sem
    // ele, um relay que cai repetidamente multiplica laços concorrentes.
    this._reconexaoEofEmAndamento = false
    // [VERIFY-1/C-78] Watermark do último frame REALMENTE aplicado (dedup de
    // replay parcial de grupo dual) — `null` = nenhum frame aplicado ainda.
    this._ultimoFrameAplicado = null
  }

  /**
   * Campos que governam o stream em voo — nascem e morrem juntos.
   *
   * ★ [15/09/2026] `_streamSeq` é o número do stream ATIVO desta instância.
   * Cada `_abrirAbortController` aborta o anterior e incrementa; quem leu o
   * número ao começar (`sendMessage`/`sendToolOutput`/`reconnect`/
   * `flowRequestMessage`/`_executeStream`) pergunta `_streamAtivo(meu)` antes
   * de escrever na store — é o que impede o encerramento de um stream
   * substituído de derrubar o `chatLoading` (ou gravar o `end`) do que acabou
   * de começar. `_streamEmVoo` é a promise da leitura ativa: a continuação de
   * uma tool de front a espera terminar antes de abrir a dela ([T024]).
   */
  _iniciarControleDeStream() {
    this.abortController = null
    this.activeReader = null
    this._streamSeq = 0
    this._streamEmVoo = null
  }

  _enqueueToken(token) {
    this._tokenBuffer.push(token)
    if (this._tokenFlushHandle !== null) return
    this._tokenFlushHandle = scheduleFrame(() => this._flushTokenBuffer())
  }

  _flushTokenBuffer() {
    this._tokenFlushHandle = null
    if (this._tokenBuffer.length === 0) return
    const batch = this._tokenBuffer
    this._tokenBuffer = []
    // [18/09/2026] O RASTRO do turno de outra conversa também não entra na
    // conversa da tela — mesma guarda (e mesma régua permissiva) que o `end`
    // já usava, ver `_turnoEhDeOutraConversa`. O buffer é esvaziado ANTES do
    // descarte: reter os tokens de A só adiaria a escrita deles ao próximo
    // flush, na conversa errada do mesmo jeito.
    // ⚠️ É esta guarda que corrige a ORDEM do `_onEventEnd`: ele força o flush
    // nas primeiras linhas e só ~20 linhas depois consulta a guarda — os
    // tokens de A já estavam gravados quando a mensagem era recusada.
    if (this._turnoEhDeOutraConversa()) return
    store.dispatch(this.storeNamespace + '/addResponseTokens', batch)
  }

  _clearTokenBuffer() {
    this._tokenBuffer = []
    if (this._tokenFlushHandle !== null) {
      cancelFrame(this._tokenFlushHandle)
      this._tokenFlushHandle = null
    }
  }

  // Buffers de INSTÂNCIA do turno — nunca escopo de módulo: dois chats abertos
  // ao mesmo tempo compartilhariam o mesmo buffer. Extraído do corpo do
  // `resetChatState` para mantê-lo legível; é a mesma limpeza de sempre.
  _resetarEstadoDaInstancia() {
    this.responseData = {}
    this.reconnectCalled = false
    // ★ [MUST, QA voz — spec-011] Nenhum delta de texto chegou AINDA neste
    // turno, nem pela fonte oficial (`FONTE_DE_TEXTO`) nem pela sombra do
    // dual-emit — ver a guarda em `_onDeltaDeTexto`.
    // ★ [15/09/2026] `_textoCompletoDaSombra`: o texto INTEIRO que chegou só
    // pela sombra do dual-emit (`text-delta` com `is_complete`, caminho do
    // Supervisor/turno de tool de front) — o `end` desses turnos vem com
    // `value.response` vazio, e sem este guardado a bolha nascia sem texto
    // até a conversa ser reaberta (persistida tem o texto). Só serve de
    // fallback quando o `end` não trouxe `response`; o turno normal segue
    // byte a byte. Zerado junto com a flag do turno (um statement só).
    // ★ merge PR #2242 — `_terminalRecebido` entra AQUI (e não como atribuição
    // solta) pelo mesmo motivo declarado acima: o teto de statements do método.
    // É o campo do Modo Agente que pertence ao TURNO — a versão da branch o
    // zerava no `_resetarEstadoLocalDoTurno`, que saiu com a refatoração dela;
    // é o que impede a reconexão por EOF de reabrir um run já fechado. (O plano
    // do turno vive só em `_planoDoTurno`, zerado em `_limparBuffersDoPainel` —
    // review Gandalf, PR #2328.)
    // ★ [spec-002 T051b/MUST-1] `_buscaWebDoTurno`: mesmo racional de
    // `_planoDoTurno` — as fontes web do turno, guardadas NA INSTÂNCIA para o
    // `end` carimbar `fontes_web` na mensagem (ver `_registrarBuscaWebDoTurno`
    // em `apiChatModoAgenteEventos.js`).
    Object.assign(this, {
      _algumDeltaDeTextoChegouNesteTurno: false,
      _textoCompletoDaSombra: '',
      _terminalRecebido: false,
      _buscaWebDoTurno: [],
    })
    // ★ [G-2 do QA] O servidor FECHOU o turno? Só o `end` e o `error` fecham.
    // Sem esta bandeira não há como distinguir "o stream acabou porque o turno
    // acabou" de "o stream acabou no meio" — nos dois casos a leitura retorna
    // normalmente, sem exceção nenhuma para o `catch` pegar.
    this._turnoFechadoPeloServidor = false
    // `_servicosCitados`/`_perguntasAoGestor`/`_painel`/`_painelSeqVisto`/
    // `_agenteDoTurno` (D6, spec-010 [T028]) — mesmo helper que `_onEventEnd`
    // usa ao fechar o turno; reusado aqui para não duplicar os 5 resets e
    // manter este método sob o teto de statements do repo.
    this._limparBuffersDoPainel()
    this._resetarToolsDeFront()
    // O frame SSE em montagem (ver `_processStreamLines`). Zerado aqui para que
    // um `event:` sem `data:` do turno anterior nunca vaze para o próximo.
    this._frameEvento = ''
    this._frameData = ''
    // spec-009 [T006] — a conversa DESTE turno, capturada no `start` (ver
    // `_onEventStart`). `cliente-identificado` não carrega `conversation_id`
    // (`contracts/events.json`): é este snapshot, e não a leitura AO VIVO de
    // `selectedConversation`, que garante que um evento tardio de um turno
    // cancelado (usuário já trocou de conversa antes de o SSE fechar) não
    // grava o cliente identificado na conversa ERRADA.
    this._conversationIdDoTurno = null
    // A conversa que NASCEU do último `start` — ver
    // `consumirConversaNascidaDoStream`.
    this._conversaNascidaDoStream = null
    // Alguém pediu o cancelamento deste stream (`_abortarStreamAtivo`). O
    // `AbortError` que vier depois é consequência disso, não falha.
    // `_inicioDoTurno` é o instante do `start` — é dele que sai o `duracao_s`
    // que o `end` carimba na mensagem (a linha de raciocínio mostra "8s" no
    // resumo do turno concluído); `null` até o `start` chegar. Num
    // `Object.assign` só para caber no teto de statements.
    Object.assign(this, { _cancelamentoPedido: false, _inicioDoTurno: null })
  }

  /**
   * Os cinco mapas das TOOLS DE FRONT do turno.
   *
   * Método próprio só para caber no `max-statements` do ESLint (14) — a régua
   * do repo é extrair, nunca desabilitar a regra. Todos moram na INSTÂNCIA, e
   * não no store, porque quem executa a ação é esta instância: o clique no
   * cartão precisa achar o `input` original sem depender de um getter que a
   * superfície pode não ter registrado, e a view lê a continuação no
   * `beforeDestroy`, quando dispatch nenhum a alcançaria a tempo.
   */
  _resetarToolsDeFront() {
    Object.assign(this, {
      // Pedidas e ainda não executadas, por `toolCallId`.
      _toolsDeFrontPendentes: {},
      // RODANDO agora ([T024]). O `end` não leva para a mensagem uma ação em
      // voo: ela iria como PENDENTE (o `router.push` demora mais que o `end`
      // chegar da rede) e o cartão reapareceria com botão sobre algo que já
      // aconteceu.
      _toolsDeFrontExecutando: {},
      // ★ [T039, spec-016, QA it.4 G-4] Todo `toolCallId` que já passou por
      // `_tratarToolDeFront` NESTE turno. O dual vocabulário do backend
      // (`core/sse.py`) pode reemitir o MESMO `tool-input-available` — medido
      // no SSE do QA (clique real em "Abrir em nova aba" abriu 3 abas para UMA
      // ação de `abrir_cliente`). Sem esta guarda, a reemissão em modo
      // AUTOMÁTICO reexecuta o handler (um SEGUNDO `window.open`/navegação
      // para o MESMO destino) e, em modo OFERECER, reinicia uma pendência já
      // resolvida. Os dois mapas acima não bastam sozinhos: o primeiro só
      // cobre o oferecido, o segundo só o automático em voo — este cobre os
      // DOIS, do primeiro evento em diante.
      _toolCallIdsTratados: {},
      // Os `toolCallId` que JÁ foram para uma mensagem deste turno. O turno de
      // tool de front tem dois `end` — o do turno que parou e o da continuação
      // — e a mesma parte em duas mensagens viraria dois cartões no thread.
      _partesJaNaMensagem: {},
      // O turno pediu uma ação ao BROWSER e a devolução está a caminho ([T024]).
      _continuacaoDeToolDeFront: false,
    })
  }

  /**
   * Segundos entre o `start` e agora, com UMA casa (o resumo da linha de
   * raciocínio mostra "4,2s") — `null` quando o turno não passou pelo `start`
   * (envelope não-stream, reconexão sem replay do `start`).
   */
  _duracaoDoTurnoEmSegundos() {
    if (typeof this._inicioDoTurno !== 'number') return null
    const decimos = Math.round((Date.now() - this._inicioDoTurno) / DECIMO_DE_SEGUNDO_MS)
    return Math.max(0, decimos / DECIMOS_POR_SEGUNDO)
  }

  // O fechamento contábil é do turno que começa agora; o do turno anterior não
  // pode sobrar na tela. Só no módulo principal, como o `_resetarFase`.
  _resetarFinish() {
    if (this.storeNamespace !== STORE) return
    store.dispatch(STORE + '/setFinishDoTurno', null)
  }

  // ★ merge PR #2242 — o corpo abaixo é o de `desenvolvimento`; a spec-002
  // tinha quebrado este método em `_resetarDispatchesDoTurno` +
  // `_resetarEstadoLocalDoTurno`, e o merge deixou a CASCA de lá chamando o
  // corpo de cá: `_resetarCanaisDoPainel`/`_resetarFase`/`_clearTokenBuffer`
  // rodavam duas vezes e `_resetarEstadoLocalDoTurno` (que saiu junto com a
  // refatoração) era um `TypeError` esperando o primeiro turno. A única linha
  // que a spec-002 acrescenta de verdade é `_resetarCanaisDoAgente()`.
  resetChatState() {
    store.dispatch(this.storeNamespace + '/setChatLoading', true)
    store.dispatch(this.storeNamespace + '/resetResponseTokens')
    store.dispatch(this.storeNamespace + '/resetThinkingSteps')
    store.dispatch(this.storeNamespace + '/resetToolCalls')
    store.dispatch(this.storeNamespace + '/resetPendingConfirmation')
    // As partes de tool são do TURNO, não da conversa (T006): o que sobrevive
    // ao reload é `tool_calls[]` na mensagem persistida.
    store.dispatch(this.storeNamespace + '/clearToolParts')
    // RF-G2 — zera o espelho AO VIVO ANTES do stream conectar: um turno
    // ABORTADO (sem `end` limpo) deixaria badges velhos na tela até o novo
    // turno rotear/fechar. Incondicional aqui; `_onEventStart` só dispatcha
    // de novo se PINADO — `_onEventStart({})` continua um NO-OP total.
    store.dispatch(this.storeNamespace + '/setAgentesDoTurnoAoVivo', [])
    this._resetarCanaisDoPainel()
    // Modo Agente (spec-002): run, cursor, plano e propostas do turno anterior
    // não podem sobreviver ao próximo (`apiChatModoAgenteEventos.js`).
    this._resetarCanaisDoAgente()
    this._resetarFase()
    this._resetarFinish()
    this._clearTokenBuffer()
    this._resetarEstadoDaInstancia()
  }

  /**
   * Gancho de captura de preview da SUPERFÍCIE — vazio no motor comum.
   *
   * ★ [spec-010 T018] O preview genérico das write-tools deixou de virar
   *   `pendingConfirmation`: o cartão `crm/confirmacao` passou a ser montado
   *   pelo REGISTRY, na parte do turno em `approval-requested` (que o
   *   `tool-output-available` já traz com o `value` inteiro). Enquanto os dois
   *   caminhos coexistiam, a MESMA proposta aparecia duas vezes no thread — o
   *   cartão e o `IaConfirmAction` que o `messages.vue` montava.
   *
   * O método continua existindo porque ele É o ponto de extensão da superfície:
   * `APIFeeFixoIa` o sobrescreve para rotear os previews que têm cartão PRÓPRIO
   * (simulação, escrita de item, envio de relatório) e chama `super` no último
   * caso — que agora, corretamente, não faz nada.
   *
   * @param {Object} data Payload do evento SSE `tool_result`.
   */
  // eslint-disable-next-line no-unused-vars
  _maybeCapturePendingConfirmation(data) {}

  /**
   * Captura os itens de `citar_servicos` do turno em andamento (spec-008 AC-4.1).
   *
   * Guarda em `this._servicosCitados` (estado de INSTÂNCIA — em escopo de módulo, dois
   * usuários simultâneos compartilhariam o mesmo buffer) e espelha no store para o
   * cartão aparecer durante o streaming. `_onEventEnd` consome e limpa.
   *
   * @param {Object} data Payload do evento SSE `tool_result`.
   */
  _maybeCaptureServicosCitados(data) {
    if (!data || data.tool !== 'citar_servicos') return
    const value = data.value || {}
    if (!value.itens || !value.itens.length) return
    this._servicosCitados = value.itens
    store.dispatch(STORE + '/setServicosCitadosStreaming', value.itens)
  }

  /**
   * Captura as perguntas de `perguntar_ao_gestor` do turno em andamento.
   *
   * Mesmo desenho de `_maybeCaptureServicosCitados`, e pelo mesmo motivo: estado de
   * INSTÂNCIA (em escopo de módulo dois usuários simultâneos dividiriam o buffer) mais
   * espelho no store, para o formulário aparecer já durante o streaming.
   * `_onEventEnd` consome e limpa.
   *
   * @param {Object} data Payload do evento SSE `tool_result`.
   */
  _maybeCapturePerguntas(data) {
    if (!data || data.tool !== 'perguntar_ao_gestor') return
    const value = data.value || {}
    if (!value.perguntas || !value.perguntas.length) return
    this._perguntasAoGestor = value.perguntas
    store.dispatch(STORE + '/setPerguntasAoGestorStreaming', value.perguntas)
  }

  /**
   * O namespace desta instância expõe os CANAIS DO TURNO (`setFaseDoTurno`,
   * `setNoDoTurno`)?
   *
   * Só o módulo principal e as conversas VIVAS (`iaConversa:<uuid>`, que
   * compõem as MESMAS actions — `store/conversa-viva.js`, paridade travada em
   * `conversa-viva.paridade-de-slices.unit.js`). O Especialista Fee-Based, o
   * ai-framework e a aba de Comissões estendem esta classe com módulos Vuex
   * SEM essas actions: despachar ali levanta `[vuex] unknown action type` a
   * cada evento — mesma regra dos canais do painel.
   *
   * ★ [review #2364, item D] Era `this.storeNamespace !== STORE`, e isso
   * deixava a conversa viva de fora: o motor dela nasce com
   * `storeNamespace: 'iaConversa:<uuid>'` (`registro-de-conversas.js`), e a
   * bolha lê a fase pelo `storeModule` DELA — na Home IA a fase nunca chegava
   * ao namespace lido e "Raciocinando"/"Elaborando resposta" não apareciam
   * (uma causa direta do "Pensando..." o tempo todo que o owner apontou).
   * `chat-event-handlers.node-status.unit.js`.
   */
  _namespaceTemCanaisDoTurno() {
    return this.storeNamespace === STORE || this._ehNamespaceDeConversaViva()
  }

  /**
   * Fase do turno (spec-007 R1, do #1961): um ponto único — cada evento passa
   * por aqui, a máquina pura decide a transição e o store alimenta o rótulo.
   *
   * ★ Só o módulo principal e a conversa viva têm a action `setFaseDoTurno`
   * (ver `_namespaceTemCanaisDoTurno`).
   *
   * `faseAposEvento` devolve a MESMA referência quando a fase não muda, então
   * o guard de identidade segura a enxurrada de `token`: um dispatch por
   * transição, não por evento.
   */
  _atualizarFase(eventType) {
    if (!this._namespaceTemCanaisDoTurno()) return
    const proxima = faseAposEvento(this._faseDoTurno, eventType)
    if (proxima === this._faseDoTurno) return
    this._faseDoTurno = proxima
    store.dispatch(this.storeNamespace + '/setFaseDoTurno', proxima)
  }

  /**
   * Encerramento comum dos catches de leitura de stream e do cancelamento.
   * Sem o reset da fase, o rótulo ficaria aceso apontando um turno que já
   * morreu — a queda de conexão não produz o evento SSE `error`.
   */
  _encerrarStreamComErro() {
    this._clearTokenBuffer()
    this._resetarFase()
    store.dispatch(this.storeNamespace + '/setChatLoading', false)
  }

  // Zera a fase E o nó do Supervisor (`noDoTurno`): os dois são o mesmo
  // canal do "passo atual", nascem e morrem juntos — no início do turno
  // (`resetChatState`), no `end` e nas quedas de stream.
  _resetarFase() {
    this._faseDoTurno = FASE_INICIAL
    if (!this._namespaceTemCanaisDoTurno()) return
    store.dispatch(this.storeNamespace + '/setFaseDoTurno', null)
    store.dispatch(this.storeNamespace + '/setNoDoTurno', null)
  }

  /**
   * Zera os canais que vivem SÓ no módulo principal (serviços citados,
   * perguntas ao gestor, painel e seus eventos). Num método próprio porque os
   * quatro dispatches apareciam em dois lugares e estouravam o teto de
   * statements — extrair é a regra do repo, não desabilitar a regra.
   */
  _resetarCanaisDoPainel() {
    store.dispatch(STORE + '/resetServicosCitadosStreaming')
    store.dispatch(STORE + '/resetPerguntasAoGestorStreaming')
    store.dispatch(STORE + '/resetPainelStreaming')
    store.dispatch(STORE + '/resetPainelEventosStreaming')
  }


  /**
   * Transcrição final do painel — guardada CRUA na instância porque
   * `_onEventEnd` a grava em `tool_calls[].painel` da mensagem. É o que faz a
   * conversa reaberta renderizar a mesma deliberação que o gestor viu ao vivo.
   *
   * Estado de INSTÂNCIA pelo mesmo motivo de `_servicosCitados`: em escopo de
   * módulo, dois chats abertos ao mesmo tempo dividiriam o buffer.
   */
  _capturePainel(data) {
    if (!data || !data.turnos || !data.turnos.length) return
    this._painel = data
    store.dispatch(STORE + '/setPainelStreaming', data)
  }

  /**
   * Um `painel_evento` — a deliberação acontecendo, evento a evento. Aqui só se
   * deduplica e se repassa: o merge é do redutor puro `reduzirEventos`, do lado
   * do store.
   *
   * O dedupe é por `seq`, monotônico por turno. No fio único ele nunca regride;
   * o guard existe para eventos atrasados do stream original chegarem depois de
   * um reconnect, que reaplicados duplicariam turnos na sala.
   *
   * ★ Dispatch no STORE fixo, nunca em `this.storeNamespace`: o canal do painel
   * só existe no módulo principal, e uma superfície com namespace próprio
   * (Fee Fixo, ai-framework) levantaria "unknown action type".
   */
  _onPainelEvento(data) {
    if (!data || typeof data.seq !== 'number') return
    if (data.seq <= this._painelSeqVisto) return
    this._painelSeqVisto = data.seq
    store.dispatch(STORE + '/aplicarPainelEvento', data)
  }

  /**
   * `plano` — os passos de negócio do Progress da preparação de reunião e
   * demais atalhos que publicam progresso (spec-001 `preparacao-reuniao`,
   * D8.2, `contracts/api.md` §3, `core/plano_vivo.py:116-128`).
   *
   * `versao` só CRESCE. O dedupe descarta qualquer evento com `versao` MENOR
   * OU IGUAL à corrente — sem ele, um evento atrasado (rede fora de ordem,
   * reconexão) faria o Progress voltar no tempo: um passo já concluído
   * voltaria a aparecer como pendente.
   *
   * ★ Dispatch no STORE fixo, mesmo motivo de `_onPainelEvento`: o Progress só
   * existe no módulo principal (home-ia) — uma superfície com namespace
   * próprio (Fee Fixo, ai-framework) nunca dispara este atalho.
   *
   * ★ [review Gandalf, PR #2328] É o ÚNICO handler do evento. O Modo Agente
   * (spec-002, US-10 — TodoWrite do relay) publica o MESMO `event: plano`, com
   * o mesmo payload `{itens, versao}`, no mesmo stream; o merge tinha
   * registrado um segundo handler (`_onEventPlano`) para a mesma chave do mapa,
   * e este ficava inalcançável. Agora um dedupe só (estrito, `>`) alimenta os
   * DOIS canais do store que o merge trouxe — `planoDoTurno` (bolha, spec-001)
   * e `plano` (painel flutuante/`messages.vue`, US-10) — e um só quadro na
   * instância (`_planoDoTurno`), que o `end` persiste em `message.plano`.
   */
  _onPlano(data) {
    if (!data || typeof data.versao !== 'number') return
    if (data.versao <= this._planoVersaoVista) return
    this._planoVersaoVista = data.versao
    // O quadro CORRENTE guardado na instância — é dele que o `end` tira o
    // registro que vai na mensagem (gap Q-0741). O store não serve de fonte
    // ali: o próprio `end` o zera, e a bolha ao vivo (que o lê) já saiu do DOM
    // quando o `chatLoading` cai, três statements antes.
    this._planoDoTurno = data
    store.dispatch(STORE + '/setPlanoDoTurno', data)
    // ⚠️ O `setPlano` do cartão de progresso NÃO sai daqui: ele mora em
    // `apiChatModoAgenteEventos.js::_onEventPlano`, que escreve no namespace
    // da CONVERSA (`_namespaceDoPlano`) — na Home IA o painel lê `plano` de
    // `iaConversa:<uuid>`, e o dispatch no store FIXO que a release fazia aqui
    // era o "corte 1" da encenação (§5.1 do CLAUDE.md, 20/09/2026).
  }

  // =====================================================================
  // D6 — agente por turno (spec-010, [T028])
  // =====================================================================

  /**
   * `agent-selected` — o Supervisor roteou o turno para um agente
   * (`contracts/events.json`: `{agent_slug, hub, motivo, id_run}`, emitido
   * logo após `route_domains`). Pode disparar MAIS DE UMA VEZ no mesmo turno
   * (fan-out) — RF-G2 acumula TODOS em `_agentesDoTurno[]`, dedupe e ordem
   * de chegada por `agentes-do-turno.js` (ver o cabeçalho dele).
   * `_agenteDoTurno` (singular, compat) é sempre `_agentesDoTurno[0]`.
   *
   * Atualiza `hubDaConversa` NA HORA (não espera o `end`) — é o que faz o
   * badge sair do estado `carregando` assim que o roteamento termina.
   */
  _onAgentSelected(data) {
    if (!data || !data.agent_slug) return
    if (data.hub) {
      store.dispatch(this.storeNamespace + '/setHubDaConversa', data.hub)
    }
    const { lista, mudou } = acumularAgente(this._agentesDoTurno, entradaDeAgentSelected(data))
    this._agentesDoTurno = lista
    this._agenteDoTurno = lista[0] || null
    if (mudou) {
      store.dispatch(this.storeNamespace + '/setAgentesDoTurnoAoVivo', lista.slice())
    }
  }

  /**
   * `node-status` — progresso por nó do `SupervisorGraph` (`{no, estado}`,
   * `estado ∈ {iniciado, concluido, falhou}`, `core/sse.py::ESTADOS_NO`).
   *
   * ★ [review #2364, item D — owner: *"a maioria do tempo fica com o
   * Pensando... ativado, não tem detalhamento"*] Era no-op. Agora alimenta o
   * canal transiente `noDoTurno` — o degrau da linha de raciocínio entre a
   * tool em voo e a fase (`utils/rotulo-do-turno.js::rotuloDoNoDoTurno`, que
   * é quem traduz o nó em copy e decide que nó de infra não vira rótulo).
   * O canal guarda só o ÚLTIMO fato: o nó seguinte substitui o anterior.
   *
   * `falhou` NÃO escreve: não pinta erro (o erro do turno tem canal próprio,
   * `_onEventError`) e o rótulo anterior fica até o próximo nó. Payload fora
   * do vocabulário fechado é ignorado — evento novo do backend não é bug.
   *
   * Mesmo namespace da fase (`_namespaceTemCanaisDoTurno`): o fixo ou a
   * conversa viva — é o que a bolha lê pelo `storeModule` dela.
   */
  _onNodeStatus(data) {
    if (!this._namespaceTemCanaisDoTurno()) return
    if (!data || typeof data.no !== 'string' || !data.no) return
    if (data.estado !== ESTADO_DO_NO.INICIADO && data.estado !== ESTADO_DO_NO.CONCLUIDO) return
    store.dispatch(this.storeNamespace + '/setNoDoTurno', { no: data.no, estado: data.estado })
  }

  // =====================================================================
  // spec-009 — cliente em foco declarado pelo SERVIDOR ([T006])
  // =====================================================================

  /**
   * [QA it.2 G-1] Promove a fixação manual PENDENTE — gravada por
   * `view-chat.vue::onTrocarEscopo` com `conversation_id: null` quando o
   * consultor fixa um cliente ANTES de a conversa existir no banco — para o
   * id que o servidor acabou de criar.
   *
   * Sem isto, o guard do AC-2.3 (`guardDeClienteFixado`) nunca bloqueava:
   * comparava `fixado.conversation_id` (sempre `null`, porque a conversa
   * ainda não tinha nascido quando a fixação aconteceu) contra o
   * `conversation_id` do evento (o id REAL, já criado) — nunca batia, e um
   * `cliente-identificado` de outro cliente no primeiro turno sobrescrevia o
   * chip fixado manualmente.
   *
   * Roda ANTES de `this._conversationIdDoTurno` ser capturado (ver
   * `_onEventStart`), para que o primeiro `cliente-identificado` do turno já
   * encontre o registro promovido.
   *
   * `fixado.conversation_id !== null` (já promovido, ou fixação normal com id
   * real) e `!data.conversation_id` (conversa RETOMADA — o `start` nem sempre
   * repete o id) são no-op: só existe o que promover quando a marca pendente
   * foi gravada E o servidor acabou de criar a conversa.
   */
  _promoverClienteFixadoPendente(data) {
    if (this.storeNamespace !== STORE) return
    if (!data || !data.conversation_id) return
    const fixado = (store.getters || {})[STORE + '/clienteFixadoManualmente']
    if (!fixado || fixado.conversation_id !== null) return
    store.dispatch(STORE + '/setClienteFixadoManualmente', {
      conversation_id: data.conversation_id,
      id_cliente_app: fixado.id_cliente_app,
    })
  }

  /**
   * `cliente-identificado` — o servidor resolveu um cliente dentro do turno E
   * conferiu a posse (`contracts/events.json`: `{id_cliente_app, codigo, nome,
   * origem, id_run, vinculo_gravado}`). O front NÃO recheca permissão: o gate
   * já rodou em `APIPermissoes.check_professional_client_app` antes de o
   * evento sair (`ui-components.md` §5 — "rbac: o front NAO recheca").
   *
   * Dois dispatches, com regras DIFERENTES:
   *
   * 1. `setClienteDaConversa` — SEMPRE, é o "a IA identificou X" (mesmo
   *    contrato de `abrir-cliente.js`, spec-016 T035): incondicional porque a
   *    tela usa isso pra desenhar o aviso "esta conversa fala de X" mesmo
   *    quando o chip continua fixado em outro cliente.
   * 2. `setClienteEscopo` — o CHIP. Só quando não há guard ativo (AC-2.3):
   *    cliente fixado MANUALMENTE nesta conversa, apontando para outro id,
   *    vence o evento. Sem o guard, o G-1 ("escritório inteiro não é
   *    sobrescrito pela navegação") reabre.
   *
   * Turno de OUTRA conversa (usuário trocou antes de o SSE fechar): o evento
   * é descartado por completo — nem o aviso pode nascer apontando pra
   * conversa errada. Comparação por SNAPSHOT (`_conversationIdDoTurno`,
   * capturado no `start`), não pela leitura ao vivo de `selectedConversation`
   * — é exatamente essa leitura ao vivo que mudaria debaixo do turno.
   */
  _onClienteIdentificado(data) {
    // "Cliente em foco" é conceito só do CRM (`escopoDeCliente` é prop
    // exclusiva de `view-chat.vue` no namespace principal — nem o drawer do
    // Fee-Based nem o `ai-framework` têm seletor de cliente). Guard igual ao
    // de `_resetarFinish`/`_onEventStart`: sem ele, `setClienteDaConversa`/
    // `setClienteEscopo` precisariam existir nos TRÊS stores
    // (`store/superficies-do-chat.unit.js` acusa a lacuna).
    if (this.storeNamespace !== STORE) return
    if (!data || data.id_cliente_app === undefined || data.id_cliente_app === null) return

    const conversationId = this._conversationIdDoTurno
    const conversaSelecionadaAgora = this._conversaAtual()
    const turnoDeOutraConversa =
      conversationId && conversaSelecionadaAgora && conversationId !== conversaSelecionadaAgora
    if (turnoDeOutraConversa) return

    // `STORE` fixo (não `this.storeNamespace`, embora o guard acima já os
    // torne idênticos aqui): é o padrão de `_resetarFinish` para o scanner
    // de `store/superficies-do-chat.unit.js` não exigir estas duas actions
    // nos OUTROS dois stores (`feeFixoIa`/`aiFramework`), que não têm
    // conceito de "cliente em foco".
    const payload = payloadClienteIdentificado(data, conversationId || conversaSelecionadaAgora)
    store.dispatch(STORE + '/setClienteDaConversa', payload)

    const fixado = (store.getters || {})[STORE + '/clienteFixadoManualmente']
    if (guardDeClienteFixado(fixado, payload)) return

    store.dispatch(STORE + '/setClienteEscopo', {
      id: payload.id_cliente_app,
      name: payload.nome,
      codigo_corretora: payload.codigo,
    })

    // SHOULD G-6 (review) — o servidor gravou o vínculo NESTE turno
    // (`vinculo_gravado: true`, UC-2 exemplo 1): trava o seletor NA HORA,
    // sem esperar reabrir a conversa. Sem isto, `escopoTravado` (que lê
    // `clienteFixadoManualmente`) continuava `false` até o próximo reload —
    // o consultor podia trocar de cliente no meio de uma conversa que o
    // servidor JÁ vinculou.
    if (data.vinculo_gravado) {
      store.dispatch(STORE + '/setClienteFixadoManualmente', {
        conversation_id: payload.conversation_id,
        id_cliente_app: payload.id_cliente_app,
      })
    }
  }

  // =====================================================================
  // Vocabulário SSE tipado (spec-001 do `project-plataforma-por-chat`, T010)
  // =====================================================================

  /**
   * O texto do turno — serve `token` (antigo) e `text-delta` (novo).
   *
   * UMA função para os dois porque eles descrevem o MESMO delta: separá-las
   * abriria espaço para as duas escreverem, que é exatamente o defeito que a
   * constante `FONTE_DE_TEXTO` existe para impedir.
   *
   * `substitui: true` TROCA o texto do turno em vez de acrescentar — é a
   * reescrita de conferência (`usecase_ia_crm_chat.py:1484`), que reemite a
   * resposta inteira corrigida. Sem isso, o gestor vê o número errado de pé e a
   * correção colada embaixo até o `end` chegar. Reset + add (e não um `set`)
   * porque `setResponseTokens` não existe nos três namespaces; estas duas
   * existem em todos.
   *
   * @param {string} origem  Nome do evento que trouxe o delta.
   * @param {Object} data    Payload do evento.
   */
  _onDeltaDeTexto(origem, data) {
    if (!data) return
    if (origem === FONTE_DE_TEXTO) {
      this._onDeltaDeTextoOficial(origem, data)
      return
    }
    this._onDeltaDeTextoSombra(origem, data)
  }

  /** A fonte OFICIAL do texto (`FONTE_DE_TEXTO`) — extraída de `_onDeltaDeTexto`
   * só para caber no teto de statements do ESLint; o comportamento é o mesmo. */
  _onDeltaDeTextoOficial(origem, data) {
    this._algumDeltaDeTextoChegouNesteTurno = true
    if (data.is_complete) return
    // [18/09/2026] Turno de outra conversa: o texto dele não é escrito nem
    // falado enquanto a tela mostra a outra. A flag acima é do TURNO (governa
    // a sombra do dual-emit) e por isso fica ANTES da guarda; o que a guarda
    // barra é a ESCRITA — inclusive o ramo `substitui`, que dispensa o buffer
    // e é o único caminho daqui que o `_flushTokenBuffer` não cobre.
    if (this._turnoEhDeOutraConversa()) return
    const texto = (origem === 'token' ? data.token : data.delta) || ''
    if (data.substitui) {
      this._clearTokenBuffer()
      store.dispatch(this.storeNamespace + '/resetResponseTokens')
      store.dispatch(this.storeNamespace + '/addResponseTokens', [texto])
      return
    }
    this._enqueueToken(texto)
    if (this._onTextoDeltaProvider && texto) this._onTextoDeltaProvider(texto)
  }

  /**
   * ★ [MUST, QA voz — spec-011] `origem` aqui é a SOMBRA do dual-emit (o
   * nome que NÃO é `FONTE_DE_TEXTO`) e por padrão seria só reconhecida e
   * ignorada — processá-la a mais duplicaria texto/fala de um turno que
   * já veio pela fonte oficial. MEDIDO no QA E2E da voz: o caminho do
   * Supervisor/turno de controle (`core/supervisor/grafo.py::_no_
   * compose_response`, `core/turno_do_servidor.py`) NUNCA emite a fonte
   * oficial — só UM evento da sombra, com `is_complete: true`, carregando
   * o texto INTEIRO como delta ÚNICO (não uma duplicata de algo já
   * processado). Sem repassar isto ao provedor de voz, o Modo de Voz
   * nunca sintetiza nesse caminho: 5/5 rodadas com `POST /voz/transcrever`
   * e `POST /chat` 200, ZERO `POST /voz/sintetizar`.
   *
   * ⚠️ A guarda `!this._algumDeltaDeTextoChegouNesteTurno` é o que mantém
   * isto seguro para o streaming NORMAL (que usa a fonte oficial com
   * vários deltas `is_complete: false` seguidos): se a fonte oficial já
   * tiver mandado QUALQUER coisa neste turno, esta sombra nunca fala nada
   * — mesmo que o backend um dia mude e passe a mandar também um
   * `is_complete: true` na sombra ao final de um streaming normal (hoje
   * não manda, medido em `usecase_ia_crm_chat.py`).
   */
  _onDeltaDeTextoSombra(origem, data) {
    if (!data.is_complete || this._algumDeltaDeTextoChegouNesteTurno) return
    const texto = (origem === 'token' ? data.token : data.delta) || ''
    if (texto) this._textoCompletoDaSombra = texto
    if (this._onTextoDeltaProvider && texto) this._onTextoDeltaProvider(texto)
  }

  /**
   * O raciocínio do turno — serve `thinking` (antigo) e `reasoning-delta`
   * (novo). Mesma regra de dedup do texto, com `FONTE_DE_RACIOCINIO`.
   */
  _onDeltaDeRaciocinio(origem, data) {
    if (origem !== FONTE_DE_RACIOCINIO) return
    if (!data) return
    // [18/09/2026] Mesma guarda do texto: o raciocínio do turno de A não entra
    // no painel de B. `addThinkingStep` escreve direto, sem buffer no meio.
    if (this._turnoEhDeOutraConversa()) return
    const texto = origem === 'thinking' ? data.content : data.delta
    store.dispatch(this.storeNamespace + '/addThinkingStep', texto || '')
  }

  /**
   * A tool foi chamada: nasce a parte, no estado `input-available`.
   *
   * É o esqueleto do cartão — o que o registry precisa para escolher o
   * componente antes de existir resultado (`ui-registry`, T004).
   */
  _onToolInputAvailable(data) {
    if (!temToolCallId(data)) return
    const parte = {
      toolCallId: data.toolCallId,
      state: ESTADO_ENTRADA,
      executor: data.executor || EXECUTOR_PADRAO,
    }
    copiarPresentes(parte, data, ['tool', 'label', 'input', 'modo'])

    // ★ G-6 (spec-016 [T025], QA `qa.json`): o `executor: 'client'` do SSE é
    // o sinal de sempre, mas não é a ÚNICA fonte — medido no SSE bruto do QA
    // (`spec016_porta_ensaio.ndjson`), o caminho do SupervisorGraph
    // (`core/supervisor/fabrica.py::_emitir_chamada_da_tool`) nunca escreve
    // `executor` nem `modo` no evento; `core/sse.py` cai então no default
    // `'server'` para uma tool que É de front. Sem este OR, a parte virava
    // uma tool comum sem `ui` — `chaveDaParte` (`partes.js`) devolve `null`
    // (não está no `LEGACY_TOOL_TO_UI`), e uma parte sem chave não vira
    // cartão NEM fallback por design: 0 cartões, nenhum botão, silêncio
    // total. O catálogo das 4 tools de front é conhecido ESTATICAMENTE aqui
    // (`TOOLS_DE_FRONT`) — a decisão é de CLASSE no backend, nunca de
    // instância (`_ToolDeFront.EXECUTOR = 'client'`), então não existe caso
    // legítimo de `navegar`/`abrir_cliente`/`preencher`/`destacar` chegando
    // como tool de servidor. Mesma redundância que `_modoDaParte` já aplica
    // ao `modo` ("por redundância do backend").
    if (parte.executor === EXECUTOR_CLIENTE || this._entradaDaToolDeFront(parte.tool)) {
      this._tratarToolDeFront(parte)
      return
    }

    store.dispatch(this.storeNamespace + '/upsertToolPart', parte)
  }

  // =====================================================================
  // Tools de FRONT (US-4) — as que o servidor NÃO executa
  // =====================================================================

  /**
   * O `ui` do cartão genérico da ação, no estado pedido.
   *
   * O cartão é montado AQUI, e não pelo backend: as tools de front declaram
   * `UI_SCHEMA = None` lá justamente porque o desenho depende do que acontece
   * no browser (ofereceu? o guard recusou? já executou?). O `namespace` viaja
   * nos props porque é por ele que o clique reencontra ESTA instância.
   */
  /**
   * @param {Object=} extra  O `output`/`devolucao` da tool — de onde saem
   *  `bloqueado`/`href` (feedback do owner, 04/09): quando o `window.open`
   *  automático foi barrado, o cartão precisa do `href` para o botão de
   *  fallback "Abrir em nova aba", que um CLIQUE real não tem bloqueado.
   */
  _uiDaAcao(parte, estado, motivo, extra) {
    // O shape vive em `ui-registry/chave-de-tool-de-front.js` porque a bolha
    // monta o MESMO cartão quando a conversa é reaberta — e lá o `ui` não
    // existe, só a chamada persistida ([T024]). Duas montagens divergiriam.
    return uiDaAcaoDeFront({
      tool: parte.tool,
      label: parte.label,
      input: parte.input,
      motivo: motivo,
      namespace: this.storeNamespace,
      estado: estado,
      bloqueado: extra && extra.bloqueado,
      href: extra && extra.href,
    })
  }

  /** A entrada do registry para uma tool de front, ou `null`. */
  _entradaDaToolDeFront(nome) {
    const chave = chaveDaToolDeFront(nome)
    if (!chave) return null
    const resolucao = resolverEntrada({ ui: { component: chave } })
    return resolucao.entrada || null
  }

  /**
   * Decide o que fazer com a tool que o BROWSER executa.
   *
   * Três desfechos, e a diferença entre eles é a US inteira:
   *
   * - `automatico` + guard ok → executa agora e devolve o `tool_output`;
   * - `automatico` + guard recusou → `output-denied` com o motivo, E o motivo
   *   vai ao modelo: ele pediu a ação e precisa saber que ela não aconteceu,
   *   senão narra ao usuário uma navegação que não houve;
   * - `oferecer` → cartão com botão, e NADA acontece até o clique. O turno já
   *   encerrou (`finish {stop_reason: 'tool_de_front'}`) e o modelo não está
   *   esperando resposta — por isso a recusa de uma ação oferecida não vira
   *   devolução: só aparece no cartão.
   */
  /**
   * O backend estreou uma tool de front antes deste deploy.
   *
   * Recusar em voz alta é o que impede o turno de ficar pendurado esperando um
   * `tool_output` que ninguém enviaria.
   */
  _recusarToolDeFrontDesconhecida(parte) {
    const motivo =
      'esta versão da plataforma não conhece a ação "' + (parte.tool || '?') +
      '". Siga a conversa em texto.'
    console.warn('[IA CRM] tool de front desconhecida:', parte.tool)
    this._encerrarToolDeFront(parte, ESTADO_RECUSA, motivo, montarRecusa(motivo))
  }

  /**
   * Marca este `toolCallId` como tratado — `true` na PRIMEIRA vez, `false`
   * nas seguintes ([T039]; ver `_toolCallIdsTratados` em
   * `_resetarEstadoDaInstancia`). Extraído para não estourar o teto de
   * statements de `_tratarToolDeFront`.
   */
  _marcarToolCallIdTratado(toolCallId) {
    if (this._toolCallIdsTratados[toolCallId]) return false
    this._toolCallIdsTratados[toolCallId] = true
    return true
  }

  _tratarToolDeFront(parte) {
    // ★ T039: reemissão do MESMO toolCallId é no-op — o dual vocabulário do
    // backend pode reemitir o MESMO `tool-input-available`. Idempotente por
    // toolCallId, não por conteúdo: a AÇÃO já foi disparada (ou já tem
    // cartão pendente) e disparar de novo é o próprio defeito medido no QA.
    if (!this._marcarToolCallIdTratado(parte.toolCallId)) return

    const entrada = this._entradaDaToolDeFront(parte.tool)
    const automatico = this._modoDaParte(parte) === MODO_AUTOMATICO

    if (!entrada) return this._recusarToolDeFrontDesconhecida(parte)

    const ctx = this._contextoDeExecucao()
    const veredito = entrada.guard(parte.input || {}, ctx)

    if (this._tratouGuardNegativo(parte, entrada, ctx, veredito, automatico)) return

    // A parte nasce com o cartão nos dois caminhos: oferecida, ele traz o
    // botão; automática, ele é o "Abrindo…" da bolha enquanto a ação roda.
    if (!automatico) this._toolsDeFrontPendentes[parte.toolCallId] = parte
    store.dispatch(this.storeNamespace + '/upsertToolPart', {
      ...parte,
      ui: this._uiDaAcao(parte, ESTADO_ENTRADA, ''),
    })

    if (!automatico) return
    this._executarToolDeFront(parte, entrada, ctx)
  }

  /**
   * [G-2 MUST, QA spec-011] Ambiguidade por nome (`abrir_cliente` com 2+
   * clientes casando) NÃO é uma recusa do guard — o cliente existe, vários,
   * na verdade — e por isso `veredito.ok` nem chega a `true`/`false` de
   * propósito nesse ramo (`resolverId`/`guard` em `abrir-cliente.js`
   * devolvem só `{requerEscolha, candidatos, instrucao}`, sem `motivo`).
   * Tratado como `!veredito.ok`, caía em `_recusarPeloGuard`, que descarta
   * `candidatos`/`instrucao` e manda `montarRecusa(undefined)` ao modelo —
   * medido: `POST /chat` com `tool_output.output = {"recusado":true}`, sem
   * candidato nenhum, e o modelo especulava na tela em vez de perguntar.
   *
   * O desfecho certo é deixar `_executarToolDeFront` rodar o `handler`
   * (`executar()`): ele chama o MESMO `guard` de novo por dentro (puro, sem
   * efeito colateral) e já monta o formato testado em `abrir-cliente.unit.js`
   * (`{requer_escolha, candidatos, instrucao}`, sem `recusado` — a
   * ambiguidade não é erro de uso da tool).
   *
   * @returns {?Promise} a Promise de `_executarToolDeFront` quando havia
   *  ambiguidade a encaminhar; `null` quando não havia (o chamador segue o
   *  próprio fluxo de `veredito.ok`).
   */
  _encaminharAmbiguidadeDoGuard(parte, entrada, ctx, veredito) {
    if (!veredito.requerEscolha) return null
    return this._executarToolDeFront(parte, entrada, ctx)
  }

  /**
   * Os dois desfechos NEGATIVOS do guard, antes da execução normal de
   * `_tratarToolDeFront`: ambiguidade por nome (só em automático — ver
   * `_encaminharAmbiguidadeDoGuard`) e a recusa comum. Devolve `true` quando
   * já tratou (o chamador só precisa retornar); `false` quando `veredito.ok`
   * e o fluxo normal deve seguir. Extraído só para caber no teto de
   * statements do ESLint.
   */
  _tratouGuardNegativo(parte, entrada, ctx, veredito, automatico) {
    if (automatico && this._encaminharAmbiguidadeDoGuard(parte, entrada, ctx, veredito)) {
      return true
    }
    if (!veredito.ok) {
      this._recusarPeloGuard(parte, veredito.motivo, automatico)
      return true
    }
    return false
  }

  /**
   * O guard recusou.
   *
   * Em `automatico` o modelo PEDIU a ação e precisa saber que ela não
   * aconteceu — a parte vai a `output-denied` e o motivo viaja no
   * `tool_output`. Em `oferecer` o turno já encerrou e ninguém está esperando
   * resposta: a recusa só aparece no cartão, com o botão desabilitado.
   */
  _recusarPeloGuard(parte, motivo, automatico) {
    const estado = automatico ? ESTADO_RECUSA : ESTADO_ENTRADA
    const devolucao = automatico ? montarRecusa(motivo) : null
    if (automatico) this._marcarContinuacaoDeToolDeFront()
    this._encerrarToolDeFront(parte, estado, motivo, devolucao)
  }

  /**
   * Declara que o turno CONTINUA depois desta ação — spec-001 [T024].
   *
   * ★ O sinal nasce ANTES de o handler rodar, e não no `sendToolOutput`, por
   * uma questão de ORDEM: o handler de `navegar`/`abrir_cliente` faz
   * `router.push`, e o push destrói a view do chat antes de a promessa dele
   * resolver. Se a view perguntasse "há continuação?" depois do POST, ela já
   * teria cancelado o stream — que é exatamente o que acontecia (E2E do
   * [T023]): o POST da continuação era abortado no cliente e o gestor via, sobre
   * a ficha recém-aberta, "a conversa não foi salva", com as duas mensagens do
   * assistente já no banco.
   */
  _marcarContinuacaoDeToolDeFront() {
    this._continuacaoDeToolDeFront = true
  }

  /**
   * O turno deixou uma devolução a caminho?
   *
   * Quem pergunta é a superfície, no `beforeDestroy`: descartar o turno aqui
   * mataria a continuação que o PRÓPRIO turno pediu. Quem consome o stream é
   * esta classe e quem guarda o resultado é a store — nenhum dos dois morre
   * com a view.
   */
  temContinuacaoDeToolDeFront() {
    return this._continuacaoDeToolDeFront === true
  }

  /** O `modo` vem no evento e, por redundância do backend, no próprio input. */
  _modoDaParte(parte) {
    if (parte.modo) return parte.modo
    const input = parte.input || {}
    return input.modo || null
  }

  /**
   * Roda o handler e devolve o resultado ao modelo.
   *
   * O `catch` NUNCA é silencioso: uma tool que estourou e não devolve nada
   * deixa o modelo achando que a tela mudou. O erro vira `output-error` na
   * parte (o cartão mostra) e viaja no `tool_output` (o modelo lê).
   */
  _executarToolDeFront(parte, entrada, ctx) {
    const self = this
    this._marcarContinuacaoDeToolDeFront()
    // Em voo: o `end` que chegar agora não leva esta parte para a mensagem —
    // ela iria como pendente, com botão, para uma ação que está acontecendo.
    this._toolsDeFrontExecutando[parte.toolCallId] = true
    return Promise.resolve()
      .then(() => entrada.handler(parte.input || {}, ctx))
      .then((output) => {
        const resultado = output || {}
        // ★ A RECUSA do handler não é uma saída bem-sucedida (QA-G-4 da
        // spec-010). Ela entrava aqui como `output-available` com motivo
        // VAZIO: o cartão não tinha o que desenhar, e o turno terminava sem
        // modal e sem mensagem — o modelo errou a chave do formulário
        // (`nova_oportunidade` em vez de `crm/nova-oportunidade`), o guard
        // fechou certo, e para quem estava na tela não aconteceu nada.
        //
        // O motivo já vem pronto do guard (e nomeia a chave pedida e as que
        // existem); o que faltava era levá-lo ao MESMO canal que a recusa do
        // guard automático já usa. Thread, e não snack: o snack some em
        // segundos e depois o thread não guarda sinal nenhum — a lição que o
        // [G-2] desta spec já custou uma iteração.
        const estado = resultado.recusado ? ESTADO_RECUSA : ESTADO_SAIDA
        const motivo = resultado.recusado ? resultado.motivo || '' : ''
        self._encerrarToolDeFront(parte, estado, motivo, resultado, resultado)
        return resultado
      })
      .catch((erro) => {
        const mensagem = (erro && erro.message) || String(erro)
        console.warn('[IA CRM] tool de front falhou:', parte.tool, erro)
        self._encerrarToolDeFront(parte, ESTADO_ERRO_DE_TOOL, mensagem, {
          erro: mensagem,
        })
        return null
      })
  }

  /**
   * Fecha a parte da tool de front e, quando há o que devolver, manda o
   * `tool_output`.
   *
   * @param {Object}  parte      A parte do turno.
   * @param {string}  estado     Estado final (`output-*` ou o de entrada).
   * @param {string}  motivo     O que o cartão mostra.
   * @param {?Object} devolucao  O `output` ao modelo. `null` = não devolve.
   * @param {Object=} valor      O que fica no `value` da parte.
   */
  _encerrarToolDeFront(parte, estado, motivo, devolucao, valor) {
    delete this._toolsDeFrontPendentes[parte.toolCallId]
    delete this._toolsDeFrontExecutando[parte.toolCallId]

    const atualizacao = {
      ...parte,
      state: estado,
      ui: this._uiDaAcao(parte, estado, motivo, devolucao),
    }
    if (valor !== undefined) atualizacao.value = valor
    if (estado === ESTADO_ERRO_DE_TOOL) atualizacao.erro = motivo
    store.dispatch(this.storeNamespace + '/upsertToolPart', atualizacao)

    if (!devolucao) {
      // Nada volta ao modelo (ação OFERECIDA, ou recusa de oferta): o turno já
      // acabou e não há continuação para a view esperar.
      this._continuacaoDeToolDeFront = false
      return
    }
    this.sendToolOutput({
      toolCallId: parte.toolCallId,
      output: devolucao,
      conversationId: this._conversaAtual(),
    })
  }

  /**
   * O clique no cartão da ação oferecida (`plataforma/acao-oferecida`).
   *
   * Chamado pelo `ui-registry/execucao.js`, que roteia pelo namespace. Devolve
   * `null` — sem estourar — quando a parte já não existe: o thread pode ter
   * sido recarregado, e um clique num cartão velho não pode derrubar a tela.
   *
   * @param {Object} opts
   * @param {string} opts.toolCallId
   * @returns {Promise<?Object>} o `output` da tool.
   */
  executarAcaoOferecida({ toolCallId, tool, label, input } = {}) {
    const parte =
      this._toolsDeFrontPendentes[toolCallId] ||
      this._parteDeCartaoReaberto({ toolCallId, tool, label, input })
    if (!parte) {
      console.warn('[IA CRM] ação oferecida sem pendência:', toolCallId)
      return Promise.resolve(null)
    }

    const entrada = this._entradaDaToolDeFront(parte.tool)
    if (!entrada) return Promise.resolve(null)

    const ctx = this._contextoDeExecucao()
    const veredito = entrada.guard(parte.input || {}, ctx)
    const resultado = this._resolverGuardNoClique(parte, entrada, ctx, veredito)
    if (resultado) return resultado

    return this._executarToolDeFront(parte, entrada, ctx)
  }

  /**
   * Os dois desfechos do guard no CLIQUE (`executarAcaoOferecida`), antes da
   * execução normal: ambiguidade por nome — aqui o usuário JÁ clicou, então,
   * diferente de `_tratouGuardNegativo`, não há "esperar confirmação" a
   * checar: vai sempre para `_executarToolDeFront` — e a recusa comum (a
   * tela mudou entre a oferta e o clique). Devolve a `Promise` já resolvida
   * quando tratou; `null` quando `veredito.ok` e o chamador deve seguir para
   * `_executarToolDeFront`. Extraído só para caber no teto de statements.
   */
  _resolverGuardNoClique(parte, entrada, ctx, veredito) {
    const emAndamento = this._encaminharAmbiguidadeDoGuard(parte, entrada, ctx, veredito)
    if (emAndamento) return emAndamento
    if (veredito.ok) return null
    // A recusa VOLTA ao modelo, então também é uma continuação a caminho.
    this._marcarContinuacaoDeToolDeFront()
    this._encerrarToolDeFront(
      parte,
      ESTADO_RECUSA,
      veredito.motivo,
      montarRecusa(veredito.motivo)
    )
    return Promise.resolve(null)
  }

  /**
   * A parte reconstruída a partir do que o CARTÃO sabe ([T024]).
   *
   * Uma conversa reaberta desenha a ação pelo `tool_calls[]` da mensagem, e
   * esta instância não tem pendência nenhuma daquele turno — ele acabou faz
   * tempo. Sem esta reconstrução, o botão que o [T024] devolveu ao thread seria
   * um botão morto: o clique só avisaria o console.
   *
   * Quem decide se a devolução vale continua sendo o SERVIDOR: o gate do [T013]
   * só aceita `tool_output` cujo id seja de uma chamada `client` da ÚLTIMA
   * mensagem do assistente daquela conversa. Uma oferta velha é recusada lá, e
   * a recusa agora chega à tela ([T024], achado 4).
   *
   * Sem `tool` não há o que executar: devolve `null` e o chamador avisa.
   */
  _parteDeCartaoReaberto({ toolCallId, tool, label, input }) {
    if (!toolCallId || !tool) return null
    return {
      toolCallId: toolCallId,
      tool: tool,
      label: label || '',
      input: input || {},
      executor: EXECUTOR_CLIENTE,
    }
  }

  /** A conversa do turno, para a devolução continuar no mesmo lugar. */
  _conversaAtual() {
    const getters = store.getters || {}
    const conversa = getters[this.storeNamespace + '/selectedConversation']
    return (conversa && conversa.id) || null
  }

  /**
   * A escrita pede confirmação: a parte vai para `approval-requested`.
   *
   * `upsertToolPart` e não `setToolPartState` por dois motivos: o evento traz
   * `preview_id`/`resumo`/`entidade`/`operacao`, que a confirmação precisa e o
   * setter de estado descartaria; e se o `tool-input-available` tiver se
   * perdido, o setter avisaria "parte desconhecida" e o cartão nunca apareceria
   * — o upsert cria a parte já no estado certo. A guarda contra a aprovação
   * ATRASADA (chegando depois do desfecho) continua sendo a máquina de estados
   * do store, que não anda para trás.
   */
  _onToolApprovalRequest(data) {
    // ★ merge PR #2242 — a proposta do Modo Agente (spec-002) entra PRIMEIRO,
    // e sem `toolCallId`: o evento do relay agêntico traz `id_proposta` e pode
    // não ter `toolCallId` nenhum, então o `return` abaixo o descartaria
    // inteiro. Uma chamada, dois destinos — aqui nasce a PARTE que o registry
    // desenha na bolha; lá, a entrada do mapa que o card decide e expira.
    this._registrarPropostaDoModoAgente(data)
    if (!temToolCallId(data)) return
    const parte = { toolCallId: data.toolCallId, state: ESTADO_APROVACAO }
    // ★ [task #169] `id_proposta` desce pela MOLDURA até o
    // `crm-confirmacao-card`, que é quem acha a entrada em `propostasAbertas`
    // (a rota de decisão da US-8). O produtor é
    // `usecases/agente/_propostas_eventos_apoio.py:61`, e o campo é
    // `required` no contrato (`$defs.d_confirmacao`) — mas `copiarPresentes`
    // só copia o que ESTÁ presente: evento sem ele (violação de contrato)
    // deixa a parte sem o campo, e o card cai no estado "sem proposta" em vez
    // de quebrar. Nada aqui inventa valor.
    // ★ [#213] `ui` entra na lista: quando a tool declara um cartão
    // (`core/ui_cartao`), é ele que escolhe o componente (`chaveDaParte` lê
    // `ui.component` antes do mapa legado) e de onde saem os `props`
    // (`propsDaParte` lê `ui.props` antes do `value`) — exatamente como o
    // Modo Chat já faz no `tool-output-available` (`core/sse.py` copia `ui`).
    // `copiarPresentes` mantém a chave AUSENTE quando o evento não a traz, que
    // é o caso de toda write-tool sem cartão próprio.
    copiarPresentes(parte, data, [
      'tool', 'preview_id', 'resumo', 'entidade', 'operacao', 'id_proposta', 'ui',
    ])
    // ★ [task #169, medido no run `a8fa1745`] O PAYLOAD do cartão.
    //
    // O evento traz os campos no TOPO (`resumo`/`entidade`/`operacao`) e no
    // `preview` (`entidade_label`/`operacao_label`) — nunca em `value`, e sem
    // `ui`. O renderer, porém, lê `propsDaParte`, que só conhece `ui.props` ou
    // `value`: sem um dos dois, `semPayloadParaDesenhar` descartava a parte e
    // NENHUM cartão era montado. Era esta a causa de o consultor ver o chip
    // "aguardando decisão" e nenhum botão.
    //
    // Nada aqui é inventado: cada campo vem do evento (`$defs.d_confirmacao`,
    // produzido por `usecases/agente/_propostas_eventos_apoio.py:61`).
    // `requer_confirmacao` é o único derivado, e por definição — o evento é um
    // PEDIDO de aprovação. Vale para os dois modos: o `d_confirmacao` do Modo
    // Chat tem o mesmo `preview`.
    const valor = valorDaPropostaParaOCartao(data)
    if (valor) parte.value = valor
    store.dispatch(this.storeNamespace + '/upsertToolPart', parte)
  }

  /**
   * A tool respondeu. `state` vem do evento porque o desfecho bom tem duas
   * caras — `output-available` e `output-denied` (a escrita que o gestor
   * recusou) — e quem sabe qual é foi o servidor.
   */
  _onToolOutputAvailable(data) {
    if (!temToolCallId(data)) return
    // ★ [T036, spec-016, QA it.3 G-6] A SENTINELA de tool de FRONT
    // (`{aguardando_browser: true}`, `core/supervisor/executor.py::
    // SENTINELA_TOOL_DE_FRONT`) é o "resultado" que o SERVIDOR devolve ao
    // MODELO para o turno seguir — nunca o resultado REAL da ação (aberto,
    // bloqueado, recusado), que só o HANDLER client-side conhece e escreve
    // via `_encerrarToolDeFront`. Depois do T029 (backend) o Supervisor
    // passou a emitir `executor: 'client'`/`modo` corretos no
    // `tool-input-available` — e revelou este bug: o handler genérico
    // sobrescrevia `parte.state` para `output-available` assim que a
    // sentinela chegasse (antes do clique, no modo oferecer; antes do
    // handler terminar, no modo automático). `partes-do-turno.vue` passa
    // `:state="parte.state"` ao cartão, e `acao-oferecida-card.vue` lê esse
    // `state` para decidir "Abrir" × "Aberto" — o cartão nascia sem botão,
    // já "Aberto", sem nenhuma aba ter sido aberta (QA it.3: `achou_botao:
    // false`). Ignorar aqui é seguro: a sentinela não carrega `ui` nem
    // `value` de negócio nenhum, só esse marcador.
    if (data.value && data.value.aguardando_browser === true) return
    const parte = { toolCallId: data.toolCallId, state: data.state || ESTADO_SAIDA }
    copiarPresentes(parte, data, ['tool', 'label', 'value', 'ui', 'annotations', 'count'])
    store.dispatch(this.storeNamespace + '/upsertToolPart', parte)
    this._fecharPropostaCommitada(parte)
  }

  /**
   * O commit de uma escrita fecha a PROPOSTA que estava esperando aprovação
   * ([spec-010 T018] / US-4).
   *
   * O commit não é a mesma tool call: o modelo re-chama a tool com
   * `confirmar=true` e o bloco `tool_use` é outro, com `toolCallId` novo. Sem
   * fechar a anterior, o cartão de proposta continua pedindo confirmação para
   * sempre — de uma escrita que já aconteceu.
   *
   * O casamento é por NOME da tool + a assinatura do commit (`changelog_id` no
   * `value`, o id da auditoria que só a gravação produz). Por estado sozinho
   * não dá: um `output-available` de leitura da mesma tool fecharia a proposta
   * sem nada ter sido gravado.
   */
  _fecharPropostaCommitada(parte) {
    const value = parte.value
    if (!value || !value.changelog_id) return
    const getters = store.getters || {}
    const partes = getters[this.storeNamespace + '/toolPartsOrdenadas'] || []
    const self = this
    partes.forEach(function(pendente) {
      if (!pendente || pendente.state !== ESTADO_APROVACAO) return
      if (pendente.tool !== parte.tool) return
      if (pendente.toolCallId === parte.toolCallId) return
      store.dispatch(self.storeNamespace + '/setToolPartState', {
        toolCallId: pendente.toolCallId,
        state: ESTADO_SAIDA,
      })
    })
  }

  /**
   * A resposta do consultor ao cartão de confirmação ([spec-010 T018] / US-4).
   *
   * O protocolo com o modelo é o MESMO de sempre — uma mensagem de texto que o
   * faz re-chamar a write-tool com `confirmar=true` (não há `tool_approval` no
   * POST; isso é a spec-004). O que muda é quem pede: era o `IaConfirmAction`
   * montado pelo `messages.vue` a partir de `pendingConfirmation`; agora é o
   * cartão do registry, na parte do turno.
   *
   * `cancelar` marca a parte como `output-denied` ANTES de falar com o modelo:
   * o cartão precisa parar de oferecer os botões no mesmo gesto do clique, e a
   * recusa vai ao modelo em seguida — sem ela, ele acha que a proposta segue de
   * pé e insiste.
   *
   * @param {Object}  opts
   * @param {string}  opts.toolCallId  A parte que está esperando aprovação.
   * @param {string}  opts.acao        `confirmar` | `cancelar`.
   * @returns {Promise<Object>} o `responseData` do turno que a resposta abriu.
   */
  responderConfirmacao({ toolCallId, acao, ...envio } = {}) {
    const cancelou = acao === ACAO_CANCELAR
    if (!cancelou && acao !== ACAO_CONFIRMAR) {
      console.warn('[IA CRM] ação desconhecida no cartão de confirmação:', acao)
      return Promise.resolve(null)
    }
    if (cancelou && toolCallId) {
      store.dispatch(this.storeNamespace + '/setToolPartState', {
        toolCallId: toolCallId,
        state: ESTADO_RECUSA,
      })
    }
    return this.sendMessage({
      ...envio,
      message: cancelou ? MENSAGEM_CANCELAR : MENSAGEM_CONFIRMAR,
      // ★ [spec-021, T004] Os campos editados só viajam no CONFIRMAR: no
      // cancelar não há o que gravar, e mandá-los ali seria ruído no corpo.
      // O servidor valida cada um contra `campos_editaveis` do preview
      // registrado (`core/campos_confirmados`) — a tela não é a autoridade
      // sobre o que se grava, só o mensageiro do que a pessoa digitou.
      camposConfirmados: cancelou ? undefined : envio.camposConfirmados,
      // ★ [spec-008, 17/09/2026] O id do cartão CLICADO — ver
      // `CHAVE_TOOL_CALL_ID_DO_CARTAO_NO_CORPO`. É o que declara ao servidor
      // que este turno foi um CLIQUE, e não uma palavra captada pelo
      // microfone com a sessão de voz aberta.
      //
      // Nos DOIS ramos, e isso é a regra e não simetria decorativa: a guarda
      // do servidor recusa o DESCARTE tanto quanto o commit (o microfone capta
      // "não" tão fácil quanto "sim", e descartar destrói a decisão que ainda
      // espera na tela). Sem o id aqui, o clique em "Descartar" dentro do Modo
      // de Voz seria engolido em silêncio.
      toolCallIdDoCartao: toolCallId,
    })
  }

  /**
   * A tool falhou. O `erro` viaja junto porque é o que o cartão de falha
   * mostra: dentro de uma conversa, o pior desfecho não é o erro — é o
   * silêncio (§17 do CLAUDE.md do módulo).
   *
   * ★ [G-3, QA rodada-v5 it.3] `ui` e `label` entraram na cópia. A falha
   * TAMBÉM tem cartão: a write-tool que erra anexa o `ui` do estado ERRO dela
   * (`tool_fee_fixo_envio_relatorio_confirmar._erro_do_commit` é um, com
   * destinatário e motivo), e o backend passou a copiá-los no evento
   * (`core/sse.py::_mapear_tool_result`). Sem isto aqui, a MESMA parte contava
   * duas histórias: a conversa REABERTA desenhava o cartão certo
   * (`parteDaChamada`, em `renderiza-partes.js`, já lia `tc.ui`/`tc.erro`/
   * `tc.state` do `tool_calls[]`) e o AO VIVO caía no `fallback-card` genérico.
   *
   * `value`/`annotations`/`count` continuam de fora, pela mesma razão do outro
   * lado do fio: o envelope de erro não tem payload. `copiarPresentes` mantém
   * a chave AUSENTE quando a tool não a mandou — `upsertToolPart` MESCLA, e um
   * `ui: undefined` apagaria o cartão que o esqueleto já tinha posto na parte.
   *
   * O vocabulário do estado é o MESMO dos dois lados (`output-error` aqui,
   * `sse.ESTADO_TOOL_ERRO` lá), então a parte viva e a persistida convergem.
   */
  _onToolOutputError(data) {
    if (!temToolCallId(data)) return
    const parte = { toolCallId: data.toolCallId, state: ESTADO_ERRO_DE_TOOL }
    copiarPresentes(parte, data, ['tool', 'label', 'erro', 'status', 'ui'])
    store.dispatch(this.storeNamespace + '/upsertToolPart', parte)
  }

  /**
   * `data-painel` carrega o MESMO payload do `painel`, que já alimenta
   * `painelStreaming` (§10 do CLAUDE.md do módulo). Reconhecido e ignorado —
   * registrar o no-op aqui, em vez de omitir o handler, é o que deixa a decisão
   * legível: omitido, ele cairia no ramo "evento desconhecido" e ninguém saberia
   * se foi escolha ou esquecimento.
   */
  _onDataPainel(data) {
    return data
  }

  /**
   * Fechamento contábil do turno: `stop_reason`, `usage` e `custo_brl`.
   *
   * NÃO fecha o turno — quem monta a mensagem e limpa os canais transientes
   * continua sendo o `end`. Só o módulo principal tem a action, pela mesma
   * razão do `setFaseDoTurno`: numa instância com namespace próprio o dispatch
   * levantaria `[vuex] unknown action type`.
   */
  _onFinish(data) {
    if (this.storeNamespace !== STORE) return
    if (!data) return
    const resumo = { stop_reason: data.stop_reason || null }
    // `agentes` (spec-010, [T016]): lista dos `agent_slug` do turno — ADITIVO,
    // só aparece quando o Gateway já preenche (`test_end_sem_agentes_...`
    // do backend trava a ausência no turno legado).
    copiarPresentes(resumo, data, ['usage', 'custo_brl', 'agentes'])
    store.dispatch(STORE + '/setFinishDoTurno', resumo)
  }

  // =====================================================================
  // Contexto de tela (US-5) e envelope sem stream (US-3)
  // =====================================================================

  /**
   * Registra QUEM sabe qual tela está aberta (US-5).
   *
   * A superfície chama isto no `created()`, tipicamente com o helper pronto
   * (`utils/provedor-de-contexto-de-tela.js` — dos componentes, nunca daqui):
   *
   *   apiChat.setContextoDeTelaProvider(provedorDeContextoDeTela(this, NS))
   *
   * A rota chega por INJEÇÃO, e não por `import '@router'` aqui, porque o
   * import fecha um ciclo que quebra o `extends APIChat` do fee-fixo — a razão
   * completa está no cabeçalho de `utils/contexto-de-tela.js`, o único util
   * de contexto que esta classe importa (e que por isso é puro).
   *
   * Sem provedor registrado, a mensagem sai com `rota_atual: null` e
   * `filtros_da_tela: {}`: a superfície perde o contexto, nunca a mensagem.
   *
   * @param {Function|null} provider  `() => ({rota_atual, filtros_da_tela})`
   */
  setContextoDeTelaProvider(provider) {
    this._contextoDeTelaProvider = typeof provider === 'function' ? provider : null
  }

  /**
   * Registra QUEM quer ver cada pedaço de texto do turno assim que chega —
   * hoje só o Modo de Voz (`view-chat.vue`), pra sintetizar frase a frase
   * conforme a IA escreve, em vez de esperar a resposta inteira terminar.
   *
   * `callback(delta)` recebe o TEXTO CRU do evento (não o acumulado) — o
   * acumulado continua vivendo só no store (`responseTokens`). Não chamado no
   * caminho `substitui: true` (reescrita de conferência, rara): re-derivar
   * segmentos já falados de uma reescrita completa é caso de borda que a
   * conversa por voz não precisa cobrir agora.
   *
   * @param {Function|null} callback  `(delta: string) => void`
   */
  setOnTextoDelta(callback) {
    this._onTextoDeltaProvider = typeof callback === 'function' ? callback : null
  }

  /**
   * [voz v3, 08/09] Registra quem quer a versão FALADA do turno — o evento
   * SSE `fala {texto}`, emitido pelo backend quando `modo_voz: true` foi
   * mandado no corpo. `callback(texto)` recebe o texto CRU do evento.
   *
   * @param {Function|null} callback  `(texto: string) => void`
   */
  setOnEventoFala(callback) {
    this._onEventoFalaProvider = typeof callback === 'function' ? callback : null
  }

  /** Handler do evento SSE `fala` (`chat-event-handlers.js`). */
  _onEventFala(data) {
    const texto = data && data.texto
    if (this._onEventoFalaProvider) this._onEventoFalaProvider(texto)
  }

  /**
   * Registra QUEM sabe qual é o router e a store desta superfície (US-4).
   *
   * A superfície chama isto no `created()`, com o helper pronto:
   *
   *   apiChat.setContextoDeExecucaoProvider(provedorDeContextoDeExecucao(this))
   *
   * ★ É um provedor SEPARADO do contexto de tela, e não um campo a mais nele,
   *   porque o de tela é serializado no CORPO do `POST /chat`: um `router` ali
   *   dentro tentaria mandar uma instância Vue ao `JSON.stringify` a cada
   *   mensagem. Este nunca sai do browser.
   *
   * Sem provedor, as tools de front recusam com motivo — nunca estouram.
   *
   * @param {Function|null} provider  `() => ({vm, router, store, canAccessRoute})`
   */
  setContextoDeExecucaoProvider(provider) {
    this._contextoDeExecucaoProvider = typeof provider === 'function' ? provider : null
  }

  /**
   * Desfaz os quatro `set*` de UMA superfície (o `beforeDestroy` dela).
   *
   * Cada campo só é zerado se ainda for a MESMA referência: na troca de rota
   * o `created` da view nova roda ANTES do `beforeDestroy` da velha, e zerar
   * sem conferir apagaria o registro recém-feito por ela.
   */
  desregistrarProvedores({ contextoDeTela, contextoDeExecucao, onTextoDelta, onEventoFala } = {}) {
    if (contextoDeTela && this._contextoDeTelaProvider === contextoDeTela) {
      this.setContextoDeTelaProvider(null)
    }
    if (contextoDeExecucao && this._contextoDeExecucaoProvider === contextoDeExecucao) {
      this.setContextoDeExecucaoProvider(null)
    }
    if (onTextoDelta && this._onTextoDeltaProvider === onTextoDelta) this.setOnTextoDelta(null)
    if (onEventoFala && this._onEventoFalaProvider === onEventoFala) this.setOnEventoFala(null)
  }

  /** O contexto de execução do momento — ou o vazio, que os guards recusam. */
  _contextoDeExecucao() {
    const provider = this._contextoDeExecucaoProvider
    if (!provider) return contextoDeExecucaoVazio()
    try {
      return provider() || contextoDeExecucaoVazio()
    } catch (e) {
      console.warn('[IA CRM] provedor de contexto de execução falhou', e)
      return contextoDeExecucaoVazio()
    }
  }

  /**
   * A tela aberta no instante do envio — `{rota_atual, filtros_da_tela}`.
   *
   * O teto de 2 KB é reaplicado AQUI, e não confiado ao provedor: quem responde
   * pelo tamanho do corpo é quem o envia, e um provedor escrito à mão numa
   * superfície nova esqueceria o corte sem ninguém perceber.
   */
  _contextoDeTela() {
    const provider = this._contextoDeTelaProvider
    if (!provider) return contextoSemTela()
    let contexto = null
    try {
      contexto = provider()
    } catch (e) {
      // A tela é acessório; a pergunta do usuário não. O aviso existe para o
      // provedor quebrado aparecer no console em vez de sumir.
      console.warn('[IA CRM] provedor de contexto de tela falhou — a mensagem segue sem a tela', e)
      return contextoSemTela()
    }
    if (!contexto) return contextoSemTela()
    return {
      rota_atual: normalizarRota(contexto.rota_atual),
      filtros_da_tela: normalizarFiltros(contexto.filtros_da_tela),
    }
  }

  /**
   * Resposta que não é stream — o envelope JSON em HTTP 200.
   *
   * O contrato da casa manda o status real no CORPO (HTTP é sempre 200), então
   * uma recusa (`403`) ou uma falha (`500`) chegam aqui com cara de sucesso.
   * Antes da spec-001 esse corpo era devolvido em silêncio: `responseData`
   * ficava `{}`, nenhum evento `error` acontecia, e o usuário via a bolha vazia
   * sem nunca saber que o servidor tinha respondido. Agora o mesmo caminho
   * acende o erro (US-3).
   *
   * Envelope de SUCESSO (ou sem `status`) segue devolvido como antes — só o
   * loading cai.
   */
  _tratarRespostaNaoStream(response) {
    // Cancelamento é decisão NOSSA, nunca falha do servidor ([T024]): solta o
    // loading e devolve o envelope como está — sem acender erro, sem tentar
    // reconectar a um turno que ninguém interrompeu do outro lado.
    if (foiCancelado(response)) return this._encerrarTurnoCancelado(response)
    const status = response && response.status
    if (typeof status !== 'number' || status === 200) {
      store.dispatch(this.storeNamespace + '/setChatLoading', false)
      return response || {}
    }
    this.responseData = {
      status: status,
      message: response.message || 'Erro inesperado. Tente novamente mais tarde.',
    }
    this._onEventError(this.responseData)
    return response
  }

  /**
   * ★ [17/09/2026] Esta superfície acompanha o RUN pelo motor (Modo Agente,
   * spec-002)?
   *
   * As duas reconexões do Modo Agente (`_reconectarPeloErroDoServidor` e
   * `_reconectarPorEofSeRunAberto`) são guardadas por `_runAtualIdRun`, e as
   * duas terminam em rotas FIXAS do `aawz_intelligence_v2`
   * (`GET /runs/{id}/eventos`, `GET /conversas/{id}/run-atual`) — não em
   * `this.endpoints`. Então quem não é do IA CRM não pode ligar esse campo:
   * seria o motor chamando a rota de outro módulo com um id que só o canal de
   * origem entende. Sobrescreva para `false` no canal sem relay de run; o
   * fecho continua sendo o `reconnect()` da própria superfície.
   *
   * @returns {boolean}
   */
  _acompanhaRunPeloMotor() {
    return true
  }

  /**
   * ★ merge PR #2242 — a conversa e o run que o `start` fixa.
   *
   * Método próprio (e não inline no `_onEventStart`) pelo teto de statements
   * do repo — mesma razão dos `Object.assign` deste arquivo.
   *
   * `conversation_id` (Modo Chat) e `id_conversa` (Modo Agente,
   * `contracts/events.json`) são o MESMO campo com dois nomes de vocabulário:
   * ler só o primeiro deixava o run agêntico sem conversa fixada e o
   * `reconectarPorCursor` sem fallback ([adv C-39]).
   */
  _fixarConversaERunDoStart(data) {
    const idConversa = data.conversation_id || data.id_conversa || null
    if (idConversa) {
      // ★ A conversa NASCEU deste stream (nenhuma estava selecionada, ou era
      // outra): marca de uso único que a view consome para NÃO reidratar — ver
      // `consumirConversaNascidaDoStream`.
      if (this._conversaAtual() !== idConversa) {
        this._conversaNascidaDoStream = idConversa
      }
      this._conversationIdAtual = idConversa
      store.dispatch(this.storeNamespace + '/setSelectedConversation', { id: idConversa })
    }
    // Modo Agente (US-13): o chip do run nasce aqui, com o cursor que esta
    // instância já conhece (`apiChatModoAgente.js::_avancarCursorSeNecessario`).
    if (!data.id_run) return
    // ★ [17/09/2026] Nem todos os canais com `id_run` no `start` são Modo Agente. O
    // agent-chat da Central de IA manda `id_run` como TRILHA DE AUDITORIA
    // (spec-004), e não como cursor de relay: ele publica UMA rota
    // (`POST /agents/<id>/chat`) e declara `chatReconnect: null`. Armar o
    // acompanhamento de run ali fazia o `error` do turno disparar
    // `GET /api/v1/intelligence-v2/runs/<id_run>/eventos?desde=N` — a rota de
    // OUTRO módulo, com o id de um run que não é dela.
    if (!this._acompanhaRunPeloMotor()) return
    this._runAtualIdRun = data.id_run
    this._dispatchNoStoreDoAgente('setRunAtual', {
      id_run: data.id_run,
      id_conversa: idConversa || this._conversaAtual() || null,
      estado: data.estado || null,
      seq: this._runAtualSeq,
      motivo: null,
    })
  }

  /**
   * "Esta conversa acabou de nascer do MEU stream?" — de uso ÚNICO.
   *
   * ⚠️ Existe para a view NÃO reidratar o run de uma conversa que este motor
   * acabou de servir ao vivo. O watcher de `selectedConversation`
   * (`view-chat-modo-agente.mixin.js`) chama `reidratarRun` a cada troca de
   * id, e o `start` de um turno do Modo CHAT troca o id (null → uuid): a
   * reidratação achava o run JÁ FECHADO daquele turno, via
   * `_drenarBacklogTerminal` reconectava no relay com `desde=0`, e o relay só
   * devolvia o `end` ~15 s depois — com `chatLoading` religado o tempo todo.
   *
   * Medido no navegador em 19/09/2026: o turno do `/onboarding` chega INTEIRO
   * em 343 ms (boas-vindas + etapa 1 + `end`), e a tela ficava em
   * "Pensando por 16 s" por causa do segundo stream.
   *
   * ★ Timing não serve de guarda aqui: o turno determinístico chega num CHUNK
   * só — `start` e `end` no mesmo tick —, então quando o watcher (assíncrono)
   * roda, `chatLoading` já caiu. Por isso a marca é explícita e posta por quem
   * selecionou a conversa.
   *
   * De uso único para NÃO engolir a reidratação legítima: quem troca de
   * conversa e volta (run aguardando decisão, US-5) encontra a marca já
   * consumida e reidrata como sempre.
   */
  consumirConversaNascidaDoStream(idConversa) {
    if (!idConversa || this._conversaNascidaDoStream !== idConversa) return false
    this._conversaNascidaDoStream = null
    return true
  }

  _onEventStart(data) {
    // Turno novo no mesmo stream: o `seq` do backend recomeça, então o dedupe
    // precisa recomeçar junto — senão o segundo painel do dia seria descartado
    // inteiro por vir com `seq` menor que o do primeiro.
    this._painelSeqVisto = 0
    // Mesmo raciocínio para o Progress do `plano` — `versao` também recomeça
    // por turno (`plano_vivo.py`).
    this._planoVersaoVista = 0
    this._inicioDoTurno = Date.now()
    this._fixarConversaERunDoStart(data)
    // [QA it.2 G-1] A conversa acabou de nascer — promove a fixação manual
    // PENDENTE (se houver) para o id real ANTES de capturar o snapshot do
    // turno abaixo, para que o guard de `_onClienteIdentificado` já compare
    // pelo id certo quando o primeiro `cliente-identificado` deste turno
    // chegar.
    this._promoverClienteFixadoPendente(data)
    // spec-009 [T006] — snapshot da conversa DESTE turno (ver o comentário do
    // campo em `_resetarEstadoDaInstancia`). Conversa nova: vem de
    // `data.conversation_id`. Conversa existente (retomada): o `start` nem
    // sempre repete o id (`resource_chat.py` já sabia qual era), então cai no
    // que já estava selecionado.
    this._conversationIdDoTurno = data.conversation_id || this._conversaAtual()
    // D6 (spec-010, [T028]) — `hub`/`agent_slug`/`agent_label` no `start` só
    // existem no turno PINADO (o hub já é sabido antes do grafo rodar). No
    // roteamento normal eles chegam depois, por `agent-selected`.
    if (data && data.hub) {
      store.dispatch(this.storeNamespace + '/setHubDaConversa', data.hub)
    }
    // RF-G2 — `agentesIniciaisDoStart` já cobre pinado ([entry]) × normal
    // ([]). O `resetChatState` (ANTES do stream conectar) já zerou
    // `agentesDoTurnoAoVivo` no store; aqui só dispatcha quando há algo NOVO
    // (pino) — é o que mantém `_onEventStart({})` um NO-OP total, contrato
    // que `apiChat.unit.js` já cobre.
    this._agentesDoTurno = agentesIniciaisDoStart(data)
    this._agenteDoTurno = this._agentesDoTurno[0] || null
    if (this._agentesDoTurno.length) {
      store.dispatch(this.storeNamespace + '/setAgentesDoTurnoAoVivo', this._agentesDoTurno.slice())
    }
  }

  _onEventEnd(data) {
    // O turno fechou pelo caminho normal ([G-2 do QA]).
    this._turnoFechadoPeloServidor = true
    // Garante que tokens pendentes sejam aplicados antes da mensagem final
    this._flushTokenBuffer()
    store.dispatch(this.storeNamespace + '/setChatLoading', false)
    // ★ merge PR #2242 — esta linha existe nos DOIS lados e mesmo assim quase
    // se perdeu: o git alinhou a declaração de `desenvolvimento` (aqui) com a
    // do `_buildMensagemFinal` que a spec-002 havia extraído, e resolver o
    // hunk a favor de um lado levava as duas. `no-undef` do eslint pegou.
    const endValue = (data && data.value) || {}
    this._fixarConversaDoEnd(data)
    // Modo Agente (spec-002): o terminal do run chegou — trava a reconexão
    // por EOF (`_tentarReconectarPorCursorNoEof`).
    this._terminalRecebido = true
    this.responseData = data
    // ★ A recusa por saldo (`gate_creditos.py`) vem como `end` 402 com o texto
    // em `value.response` — NÃO é uma resposta do agente, é o turno que não
    // saiu. Vira a bolha de erro de saldo (com a porta para os créditos), e
    // não uma mensagem comum que pareceria a IA conversando.
    if (ehBloqueioPorSaldo(data)) return this._fecharTurnoBloqueadoPorSaldo(endValue)
    // [15/09/2026] O `end` de um turno cuja conversa já não é a selecionada
    // (o gestor trocou de conversa no meio — a continuação de uma tool de
    // front é o caso que a view NÃO cancela, [T024]) não vira mensagem da
    // conversa da tela: a resposta está gravada na conversa de origem e
    // aparece ao reabri-la. Gravar aqui era a resposta de A caindo em B.
    if (this._turnoEhDeOutraConversa()) return this._fecharTurnoDeOutraConversa()
    const newMsg = {
      id: data.id || null,
      role: 'assistant',
      // `end` sem `response` (turno de tool de front / Supervisor): o texto
      // que veio só pela sombra é o da mensagem — ver `_textoCompletoDaSombra`.
      content: endValue.response || this._textoCompletoDaSombra || '',
      thinking_steps: endValue.thinking || [],
      sources: endValue.sources || [],
      feedback: null,
      tool_calls: this._buildToolCallsRegistrados(),
      // True apenas quando o backend esgotou as continuações automáticas e a
      // resposta permaneceu cortada pelo teto de tokens (spec-005). Veio do
      // #1961; o reconnect devolve a mesma chave, derivada de `stop_reason`.
      truncada: Boolean(endValue.truncada),
      // [QA it.2 G-3] Mesmas duas chaves que o histórico devolve por mensagem
      // (US-4/AC-4.3, `resource_messages.py`: `agent_slug`/`hub` via
      // `id_run → runs.agent_slug → agentes.hub`) — gravadas aqui, na
      // mensagem AO VIVO, e não só no mapa `agentePorMensagem`
      // (`_comitarAgentesDoTurno`, logo abaixo). Sem isto, o getter
      // `agenteAtualDaConversa` (`store/hub-e-agente.js`) ficava sem fonte no
      // exato instante em que `_comitarAgentesDoTurno` zera
      // `agentesDoTurnoAoVivo` — o fallback por histórico
      // (`agenteDaUltimaMensagemAssistant`) lê os campos DA MENSAGEM, e a
      // mensagem recém-criada não os tinha até a conversa ser recarregada do
      // servidor. `null` (nunca `undefined`) quando não há agente resolvido
      // neste turno (AC-4.5 — nunca inventa hub).
      agent_slug: (this._agenteDoTurno && this._agenteDoTurno.agentSlug) || null,
      hub: (this._agenteDoTurno && this._agenteDoTurno.hub) || null,
      // [11/09/2026] Quanto o turno durou, para a linha de raciocínio da
      // mensagem persistida mostrar o "Ns" ao lado do resumo. Só a mensagem
      // criada AO VIVO tem — o histórico (`GET /messages`) não traz o campo.
      duracao_s: this._duracaoDoTurnoEmSegundos(),
      // [spec-002 T051b/MUST-1, review PR #2328] Carimba `fontes_web` na
      // mensagem AO VIVO — sem isto o cartão de fonte web (T050/T051) some
      // ANTES do F5: `resetChatState` zera o canal transiente `buscaStreaming`
      // no INÍCIO do turno SEGUINTE, e a mensagem já gravada no Vuex nunca
      // era atualizada com o dado. `GET /messages` (backend) resolve o F5;
      // isto resolve a sessão contínua. `[]` (nunca `undefined`) sem busca.
      fontes_web: fontesWebDoTurno(this._buscaWebDoTurno),
      // [gap Q-0741] O quadro final do Progress do atalho, pela MESMA razão e
      // com a mesma vida do `duracao_s` acima: só a mensagem criada AO VIVO o
      // tem (o `GET /messages` não traz o campo). Sem ele o consultor nunca
      // via os passos riscados — o último `plano` do SSE chega menos de um
      // segundo antes do `end`, que derruba o `chatLoading` (tirando a bolha
      // ao vivo do DOM) e zera `planoDoTurno`. Só o plano TERMINADO viaja:
      // um plano parado no meio, congelado na bolha, afirmaria trabalho em
      // curso numa resposta que já acabou.
      // [spec-008 T028] O run que produziu este turno — a MESMA chave que
      // `GET /messages` devolve por mensagem (`resource_messages.py`). É por
      // ela que a bolha recorta as ENTREGAS da conversa
      // (`chat-message.vue::entregasDoTurno`): sem o carimbo aqui, o arquivo
      // que o agente acabou de produzir só apareceria depois de reabrir a
      // conversa — a promessa da US-4 ("o consultor baixa") ficaria valendo
      // só depois de um F5. `null` fora do Modo Agente (Modo Chat, drawer do
      // Fee Fixo, ai-framework): lá nunca houve run.
      id_run: this._idRunDoTurno(),
      plano: this._planoParaAMensagem(),
      // [T101, spec-001 `pesquisa-internet-chat`] `busca`/`codigo`/`arquivo`
      // do turno — espalhados de `_canaisDoAgenteDoTurno()` (mixin do Modo
      // Agente), que documenta por que a mensagem precisa deles e o que
      // continua sem cobertura depois de um F5. Espalhado, e não três
      // atribuições: `_onEventEnd` está no teto de statements do ESLint.
      ...this._canaisDoAgenteDoTurno(),
    }
    store.dispatch(this.storeNamespace + '/addMessage', newMsg)
    this._comitarAgentesDoTurno(newMsg)
    this._zerarEstadoAoFimDoTurno()
  }

  /**
   * O run que produziu este turno, normalizado — `null`, nunca `undefined`
   * (`_onEventStart` copia `data.id_run` cru, que pode vir ausente).
   *
   * Método próprio, e não `|| null` inline: `_onEventEnd` já está no teto de
   * complexidade do ESLint do repo, e um ramo a mais ali o estoura.
   */
  _idRunDoTurno() {
    return this._runAtualIdRun || null
  }

  /**
   * O quadro do `plano` que vai NA mensagem do turno (gap Q-0741).
   *
   * Só o plano TERMINADO viaja: um plano parado no meio, congelado na bolha
   * para sempre, afirmaria trabalho em curso numa resposta que já acabou — o
   * mesmo engano do defeito original, de cabeça para baixo.
   *
   * Método (e não um ternário no literal) porque o `_onEventEnd` já está no
   * teto de complexidade do repo — extrair é a regra daqui, não desabilitar a
   * regra; mesmo precedente de `_limparBuffersDoPainel`.
   *
   * ★ [review Gandalf, PR #2328 + merge 21/09/2026] O evento `plano` é UM
   * só no stream (relay e fio de chat), despachado por
   * `chat-event-handlers.js` para os dois consumidores — `_onPlano` (este
   * quadro, `_planoDoTurno`) e `_onEventPlano` (o canal `plano` do cartão de
   * progresso, no namespace da CONVERSA). Quem viaja em `message.plano` é
   * este quadro, e a regra do Q-0741 vale para o Modo Agente também: um run
   * que parou no meio (erro, cancelamento) não deixa uma lista "em
   * andamento" congelada para sempre na resposta.
   */
  _planoParaAMensagem() {
    return planoTerminado(this._planoDoTurno) ? this._planoDoTurno : null
  }

  /**
   * O `end` 402: a bolha de erro de saldo no lugar da mensagem, e o mesmo
   * fecho de estado do turno normal (tokens da revelação, tool calls, painel,
   * fase, buffers). `id: null` — nenhuma mensagem foi gravada, e o espelho de
   * agentes ao vivo é zerado do mesmo jeito.
   */
  _fecharTurnoBloqueadoPorSaldo(endValue) {
    this._desfechoDeSaldoEsgotado(endValue.response)
    this._comitarAgentesDoTurno({ id: null })
    this._zerarEstadoAoFimDoTurno()
  }

  /**
   * O turno pertence a OUTRA conversa que não a selecionada. Só afirma quando
   * os dois ids são conhecidos: sem snapshot (envelope não-stream, reconexão
   * sem replay do `start`) ou sem conversa selecionada, o `end` segue o
   * caminho de sempre — descartar por dúvida apagaria resposta legítima.
   */
  _turnoEhDeOutraConversa() {
    const doTurno = this._conversationIdDoTurno
    const atual = this._conversaAtual()
    return Boolean(doTurno && atual && String(doTurno) !== String(atual))
  }

  // O `end` que não é desta conversa: mesmo fecho de estado, sem mensagem.
  _fecharTurnoDeOutraConversa() {
    this._comitarAgentesDoTurno({ id: null })
    this._zerarEstadoAoFimDoTurno()
  }

  // O que cada `end` zera depois de gravar (ou não) a mensagem do turno.
  _zerarEstadoAoFimDoTurno() {
    store.dispatch(this.storeNamespace + '/resetResponseTokens')
    store.dispatch(this.storeNamespace + '/resetToolCalls')
    this._resetarCanaisDoPainel()
    this._resetarFase()
    this._limparBuffersDoPainel()
    // O Progress só existe enquanto o turno roda — dali em diante o consultor
    // já está lendo o documento (`documento/preparo-de-reuniao`) no painel
    // lateral. Dispatch no STORE fixo, mesmo motivo de `_onPlano`.
    store.dispatch(STORE + '/setPlanoDoTurno', null)
  }

  /**
   * Os buffers do painel NA INSTÂNCIA, zerados ao fim do turno.
   *
   * Extraído do `_onEventEnd` (o merge de 27/08 juntou o reset dos dois lados e
   * o método passou do teto de statements do repo — extrair é a regra daqui,
   * não desabilitar a regra). NÃO é o `_resetarEstadoDaInstancia`: aquele
   * também zera `_toolsDeFrontPendentes`, e no `end` de um turno com tool de
   * front ainda em voo isso apagaria a ação que o gestor está prestes a
   * confirmar.
   */
  _limparBuffersDoPainel() {
    this._servicosCitados = []
    this._perguntasAoGestor = []
    this._painel = null
    this._painelSeqVisto = 0
    // O Progress do `plano` é só de INSTÂNCIA aqui (o contador); quem limpa o
    // valor no STORE é `_zerarEstadoAoFimDoTurno` — este método também roda no
    // construtor (`_resetarEstadoDaInstancia`), onde um dispatch seria
    // prematuro/alheio ao módulo principal.
    this._planoVersaoVista = 0
    // O quadro guardado morre com o turno, pelo mesmo motivo do contador: o
    // `end` já o copiou para a mensagem, e deixá-lo aqui faria o PRÓXIMO turno
    // (um atalho sem plano, uma pergunta comum) fechar com o plano do turno
    // anterior na bolha. São DOIS quadros com a mesma vida (merge com a
    // `release/ia-claude-code`, 21/09/2026): `_planoDoTurno` (`_onPlano`, o
    // Progress dos atalhos) e `_planoAtual` (`_onEventPlano`, o Modo Agente) —
    // desde que o handler `plano` alimenta os dois, só zerar o primeiro deixava
    // o segundo vazar pelo `_planoParaAMensagem` para o `end` seguinte.
    this._planoDoTurno = null
    this._planoAtual = null
    // D6 (spec-010, [T028]) — já comitado em `agentePorMensagem` acima; o
    // buffer não pode sobreviver ao turno, senão o PRÓXIMO turno (sem
    // `agent-selected` próprio — ex.: motor legado) herdaria o agente do
    // turno anterior.
    this._agenteDoTurno = null
    // RF-G2 — mesma disciplina, para a lista completa. Só a memória LOCAL:
    // o espelho ao vivo no store já foi zerado por quem fecha o turno
    // (`_onEventEnd`), e aqui pode rodar também a partir do construtor
    // (`_resetarEstadoDaInstancia`), antes de qualquer stream existir.
    this._agentesDoTurno = []
  }

  /**
   * RF-G2 (verdict de review front, spec-010) — comita `agentePorMensagem`
   * (quando há `id`) e zera o espelho ao vivo. Extraído do `_onEventEnd`
   * para não estourar o teto de statements do repo (mesma regra que já
   * extraiu `_limparBuffersDoPainel`, acima).
   *
   * D6 ([T028]) — sem `id` (motor legado sem o `id` do `end`, ou o dual não
   * trouxe o campo) não há chave para gravar — o badge cai no estado
   * `vazio`, nunca num id inventado. `payloadDeComitarAgente` já resolve
   * esse `null`. O espelho ao vivo é zerado INCONDICIONALMENTE: o turno
   * FECHOU, o badge da mensagem persistida já lê `agentePorMensagem`
   * (comitado acima, quando houve o quê), e o buffer não pode sobreviver
   * pro PRÓXIMO turno.
   */
  _comitarAgentesDoTurno(newMsg) {
    const payload = payloadDeComitarAgente(newMsg.id, this._agenteDoTurno, this._agentesDoTurno)
    if (payload) {
      store.dispatch(this.storeNamespace + '/setAgenteDaMensagem', payload)
    }
    store.dispatch(this.storeNamespace + '/setAgentesDoTurnoAoVivo', [])
  }

  /**
   * Monta o `tool_calls` da mensagem no MESMO shape que o backend persiste
   * (ver `ToolCallRegistrado` em `contracts/api.yaml`).
   *
   * É o que faz a mensagem ao vivo e a mensagem recarregada renderizarem idênticas por
   * construção: `extrairServicosCitados` lê os dois caminhos com uma única regra, sem
   * coluna nova no banco.
   *
   * @returns {Array} `tool_calls` da mensagem, ou `[]` quando o turno não citou
   *   serviço nem deliberou.
   */
  _buildToolCallsRegistrados() {
    const registros = []
    const itens = this._servicosCitados
    if (itens && itens.length) {
      registros.push({ name: 'citar_servicos', input: {}, id: null, output: { itens } })
    }
    // Mesmo shape do backend (`_success_response` da tool): as perguntas moram em
    // `output.perguntas`, que é o que `extrairPerguntasAoGestor` procura.
    const perguntas = this._perguntasAoGestor
    if (perguntas && perguntas.length) {
      registros.push({
        name: 'perguntar_ao_gestor',
        input: {},
        id: null,
        output: { perguntas },
      })
    }
    // ★ `painel` é chave IRMÃ de `name`, NÃO vai em `output` — é assim que o
    // backend persiste (`usecase_ia_crm_chat.py:880`) e é o que
    // `utils/extrair-painel.js` procura.
    if (this._painel) {
      registros.push({ name: 'convocar_painel', input: {}, id: null, painel: this._painel })
    }
    return registros.concat(this._partesDoTurnoParaAMensagem())
  }

  /**
   * As partes de tool do turno, no shape em que o backend as persiste ([T024]).
   *
   * ★ É isto que faz o cartão SOBREVIVER ao fim do turno. As partes vivem no
   * slice `toolParts`, e o thread só as desenha enquanto `chatLoading` é true
   * (`messages.vue`: `showStreamingMessage = chatLoading`). Como uma tool de
   * front ENCERRA o turno, o botão "Abrir" ficava na tela por milissegundos —
   * medido no E2E do [T023]: `botão "Abrir" depois do fim do turno: 0`. Levando
   * as partes para a mensagem, quem desenha passa a ser a bolha persistida, que
   * é a mesma que a conversa reaberta usa.
   *
   * Duas exclusões, e as duas são sobre NÃO desenhar duas vezes:
   *
   * - as tools com registro próprio acima (`citar_servicos`, `convocar_painel`)
   *   — o registro delas carrega a forma que os extratores esperam;
   * - as partes já levadas por um `end` anterior DESTE turno — o turno de tool
   *   de front tem dois (o que parou e o da continuação).
   *
   * E uma espera: a tool de front que está EXECUTANDO agora fica para o `end`
   * seguinte, com o desfecho dela. Registrá-la em voo carimbaria na mensagem um
   * cartão pendente para uma ação que já aconteceu.
   */
  _partesDoTurnoParaAMensagem() {
    const getters = store.getters || {}
    const partes = getters[this.storeNamespace + '/toolPartsOrdenadas'] || []
    const registros = []
    for (const parte of partes) {
      const id = parte && parte.toolCallId
      if (!id) continue
      if (this._partesJaNaMensagem[id]) continue
      if (this._toolsDeFrontExecutando[id]) continue
      if (TOOLS_COM_REGISTRO_PROPRIO.indexOf(parte.tool) !== -1) continue
      this._partesJaNaMensagem[id] = true
      registros.push(this._registroDaParte(id, parte))
    }
    return registros
  }

  /** Uma parte do turno no shape em que o backend persiste o `tool_calls[]`. */
  _registroDaParte(id, parte) {
    return {
      id: id,
      name: parte.tool || '',
      input: parte.input || {},
      executor: parte.executor || EXECUTOR_PADRAO,
      // ★ O ESTADO vai junto (espelho do que o backend passou a persistir no
      // `tool_calls[]`). Sem ele, a parte que voltasse desta mensagem seria
      // lida como `output-available` pelo `parteDaChamada` — uma proposta
      // pendente virava recibo de escrita feita, com o botão vivo por cima.
      state: parte.state || null,
      // `undefined` viraria chave ausente no JSON e o renderer não saberia
      // distinguir "sem resposta" de "não veio no payload".
      output: parte.value === undefined ? null : parte.value,
      ui: parte.ui || null,
      // ★ [STRESS r2, G-6] `label` e `erro` FALTAVAM aqui — o turno SEGUINTE
      // da mesma sessão (sem reload) remonta a bolha a partir DESTE registro
      // (`parteDaChamada` em `renderiza-partes.js`, que já sabia ler
      // `tc.label`/`tc.erro` — só ninguém os escrevia). Sem eles, o cartão de
      // falha (`textoDaFalha`, `ui-registry/partes-do-turno/partes.js`) caía
      // no genérico "a ferramenta falhou sem dizer o motivo", e o badge
      // perdia o rótulo — mesmo com o motivo completo tendo aparecido AO VIVO
      // segundos antes, na MESMA parte.
      label: parte.label || null,
      erro: parte.erro || null,
    }
  }

  /**
   * O turno morreu — e a EXPLICAÇÃO do servidor tem de chegar a quem chamou.
   *
   * ★ [T024], achado 4 do E2E. Até aqui a `message` do servidor ia só para o
   * `console.error`: a superfície recebia `responseData` vazio e mostrava uma
   * copy fixa ("não foi possível enviar"). Medido em 26/08/2026 com um
   * envelope `{status: 500, message: 'forjado pelo E2E'}` — a única frase que
   * dizia O QUE aconteceu não aparecia em lugar nenhum da tela. Dentro de uma
   * conversa, o pior desfecho não é o erro; é o erro sem explicação (§17).
   *
   * A mensagem NÃO ganha default aqui de propósito: sem explicação do
   * servidor, quem escolhe a copy é a superfície, que sabe o que o usuário
   * estava fazendo. Inventar um texto genérico aqui apagaria essa escolha.
   *
   * E quando vai RECONECTAR, o erro não é carimbado: a reconexão é que vai
   * preencher o `responseData` com o `end` do turno recuperado, e acusar falha
   * de um turno que voltou inteiro seria pior que não acusar nada.
   */
  _onEventError(data) {
    // O servidor FALOU sobre o desfecho — mesmo para reconectar. O fecho do
    // stream que vem depois disto não é anômalo, e carimbar uma segunda bolha
    // de erro seria dizer duas vezes a mesma morte ([G-2 do QA]).
    this._turnoFechadoPeloServidor = true
    // Modo Agente (spec-002): o run fechou — nada de reconexão por EOF depois
    // disto (é o que `_deveReconectarPorEof` lê).
    this._terminalRecebido = true
    store.dispatch(this.storeNamespace + '/setChatLoading', false)
    store.dispatch(this.storeNamespace + '/resetToolCalls')
    this._clearTokenBuffer()
    console.error('[IA CRM] Erro do servidor:', data.message)
    if (this._reconectarPeloErroDoServidor(data)) return
    this.responseData = {
      status: data.status || STATUS_ERRO_DO_TURNO,
      message: data.message || '',
    }
    if (ehBloqueioPorSaldo(data)) {
      this._desfechoDeSaldoEsgotado(data.message)
    } else {
      this._registrarTurnoComErro(data.message)
    }
    this._falarDesfechoDeErro(data.message)
  }

  /**
   * O desfecho ÚNICO do 402, venha do `end` do fio ou do envelope de erro: a
   * bolha de saldo esgotado (texto do servidor mantido, SEM "Tentar de novo" —
   * reenviar sem saldo só repete a recusa) e o sinal para quem cuida da
   * carteira: o rodapé da lateral pulsa para o consultor achar o botão "Meus
   * créditos", e o composer liga a faixa de bloqueio (`CREDITOS.CHAMAR_ATENCAO`,
   * `@constants/Text`). O saldo em si é relido no fecho do stream, como sempre
   * (`_avisarQueOSaldoMudou`).
   */
  _desfechoDeSaldoEsgotado(mensagem) {
    this._registrarTurnoComErro(mensagem, { saldoEsgotado: true })
    if (this._cancelamentoPedido === true) return
    GlobalBus.$emit(CREDITOS.CHAMAR_ATENCAO)
  }

  /**
   * [spec-019 T004] O turno falhou — e quem está OUVINDO precisa saber, não
   * só quem está OLHANDO a tela. O servidor já faz a parte dele
   * (`resource_chat.py:823-848` embrulha `usecase.atender` inteiro e emite
   * `error` com o desfecho — D4-bis do `research.md`); o defeito medido era
   * só o front: `_onEventError` monta a bolha (`_registrarTurnoComErro`) mas
   * nunca fala, mesmo com o Modo de Voz ligado — o consultor ouve silêncio e
   * interpreta como "ainda pensando".
   *
   * ★ Reusa o MESMO caminho que a fala do turno normal usa
   * (`processarEventoFala`, o handler do evento SSE `fala` — ver
   * `_onEventFala` acima): não é um segundo mecanismo de síntese, é a MESMA
   * fila recebendo mais uma frase. Como o `error` chega NO MEIO do stream, a
   * fala progressiva do turno (`motorDeVoz.sessaoDeVozAtiva`) já foi
   * ARMADA por quem chamou `sendMessage`/`sendToolOutput`/
   * `reenviarUltimoTurno` (via `iniciarFalaProgressiva`, no início do
   * envio) — esta função só ENFILEIRA mais uma frase na geração corrente; o
   * `finally` de quem chamou fecha a fala como sempre
   * (`finalizarFalaProgressiva`), sem precisar de um par próprio aqui.
   * `processarEventoFala` já é no-op se a fala progressiva não estiver
   * armada (turno sem voz) — não precisa duplicar essa guarda aqui.
   *
   * Sem frase ANTERIOR na fila (turno mudo até aqui, erro logo de cara),
   * esta é a única; com frase ANTERIOR (o turno já tinha emitido `fala` ou
   * texto antes de quebrar), esta entra DEPOIS, na ordem — SOMA, nunca
   * descarta nem duplica a que já estava lá.
   *
   * ★ [delta do team-lead, 09/09] `data.message` NÃO é falado cru — passa
   * por `copyDoErroDoTurno` (`utils/copy-do-erro-do-turno.js`), a MESMA
   * régua que `chat-message.vue::textoDoErroDoTurno` usa para decidir o
   * texto da BOLHA. Sem isso, um erro em que a mensagem escapa técnica
   * (traceback, `NomeError`, caminho `.py`) fazia a TELA mostrar a copy
   * limpa e a VOZ ler o traceback em voz alta — pior que o silêncio que
   * esta task veio consertar, e exatamente o "sem código cru" do AC2. A
   * função nunca devolve vazio (cai na copy padrão), então a fala SEMPRE
   * diz algo quando chega até aqui — paridade completa com a bolha, que
   * também nunca fica muda.
   *
   * AC4 (US-4) — as MESMAS duas exceções que `_fechouSemDesfecho` já
   * declara, sem reinventar a régua: cancelamento pedido pelo usuário (foi
   * decisão dele, falar seria ruído) e reconexão em voo (o turno pode
   * voltar inteiro — acusar falha dele seria mentira, mesma razão do
   * `responseData` acima). A reconexão nunca chega aqui: o branch acima
   * retorna antes. O cancelamento é checado explicitamente, mesma condição
   * que `_registrarTurnoComErro` usa para não montar a bolha.
   */
  _falarDesfechoDeErro(mensagem) {
    if (this._cancelamentoPedido === true) return
    if (!motorDeVoz.sessaoDeVozAtiva) return
    processarEventoFala(copyDoErroDoTurno(mensagem))
  }

  /**
   * O turno morreu — e o THREAD guarda o vestígio (design G-2 da VERIFY it.2).
   *
   * O snack já mostrava a `message` do servidor, mas ele some em segundos: dez
   * segundos depois, a conversa não tinha nenhum sinal de que um turno havia
   * falhado — só o texto de volta no composer. O wireframe §3 e o AC de US-3
   * pedem as duas coisas ("snack + estado da mensagem"), e é a segunda que
   * sobrevive à rolagem: a bolha de erro fica no lugar onde a resposta deveria
   * estar, com o motivo e o "Tentar de novo".
   *
   * Três recusas, e cada uma seria uma mentira diferente na tela:
   *
   * - **cancelamento deliberado** — interromper foi decisão do usuário ([T024]);
   * - **reconexão a caminho** — o turno pode voltar inteiro, e acusar falha de
   *   um turno recuperado é pior que não acusar nada (mesma regra do
   *   `responseData`, logo acima);
   * - **sem envio anterior** — sem saber o que reenviar, a bolha vem sem botão
   *   (`pode_tentar_de_novo: false`), nunca com um botão morto.
   *
   * A copy NÃO ganha default aqui, pelo mesmo motivo do `responseData`: quem
   * escolhe o texto genérico é quem desenha (o `chat-message` tem o dele).
   *
   * Só usa `addMessage`, que é a ÚNICA action de mensagem presente nos três
   * namespaces do chat (`aawz-intelligence-v2`, `feeFixoIa`, `aiFramework`) —
   * uma action nova exigiria espelho manual nos três, e o namespace que
   * esquecesse falharia com `[vuex] unknown action type` em silêncio.
   */
  _registrarTurnoComErro(mensagem, { saldoEsgotado = false } = {}) {
    if (this._cancelamentoPedido === true) return
    // [18/09/2026] QUARTA recusa, e a mesma mentira das outras três vista de
    // outro ângulo: o turno que morreu era de OUTRA conversa, e a bolha de
    // erro dele apareceria dentro da conversa que o gestor está lendo — com um
    // "Tentar de novo" que reenviaria a pergunta de A para dentro de B.
    if (this._turnoEhDeOutraConversa()) return
    store.dispatch(this.storeNamespace + '/addMessage', {
      id: null,
      role: 'assistant',
      content: '',
      thinking_steps: [],
      sources: [],
      feedback: null,
      tool_calls: [],
      erro_do_turno: {
        message: String(mensagem === null || mensagem === undefined ? '' : mensagem),
        namespace: this.storeNamespace,
        // Saldo esgotado NUNCA oferece o reenvio: sem crédito a repetição só
        // repete a recusa. A bolha ganha, no lugar, a porta para os créditos.
        pode_tentar_de_novo: !saldoEsgotado && Boolean(this._ultimoEnvio),
        saldo_esgotado: saldoEsgotado,
      },
    })
  }

  /**
   * [spec-016 T004] A voz ESCOLHIDA na conversa tem que alcançar todos os
   * envios de voz, não só o gatilho original de `view-chat.vue::onEnviarVoz`
   * — inclusive estes dois caminhos de CONTINUAÇÃO de turno
   * (`reenviarUltimoTurno`, `sendToolOutput`), que decidem o Modo de Voz por
   * conta própria (ADR-017-01/T003). Esta classe não é um componente — sem
   * `this.$store` — mas já lê o Vuex direto (`import store from '@state/store'`
   * no topo do arquivo); o mesmo `this.storeNamespace` usado nos dispatches
   * serve para ler o state. Namespace sem a chave `vozSelecionada`
   * (`feeFixoIa`/`aiFramework`, que não têm esse estado) cai no fallback
   * `''` — sem voz específica, o `motor-de-voz.js` já trata isso como
   * "toca com a voz padrão do ElevenLabs".
   *
   * @returns {string} o `voice_id` escolhido, ou `''`.
   */
  _vozSelecionadaAtual() {
    const st = (store.state || {})[this.storeNamespace] || {}
    return st.vozSelecionada || ''
  }

  /**
   * Reenvia o ÚLTIMO texto do usuário, na conversa em que ele está.
   *
   * É o que o botão "Tentar de novo" da bolha de erro chama, pelo índice de
   * executores por namespace (`ui-registry/execucao.js`) — o mesmo caminho do
   * cartão de ação oferecida, e pelo mesmo motivo: o drawer do Fee Fixo não
   * pode reenviar pela conversa do chat do CRM.
   *
   * A conversa vem do STORE, não do envio antigo: o turno pode ter morrido
   * depois de o backend criar a conversa, e repetir `conversation_id: null`
   * abriria uma conversa nova a cada tentativa.
   *
   * ★ **[spec-017 T003] Sobrevive ao Modo de Voz.** `envio.modoVoz` é o que o
   * turno ORIGINAL levou, congelado no momento da falha — mas quem decide se
   * ESTE reenvio fala é a sessão de voz LIDA AGORA (ADR-017-01), no clique do
   * "Tentar de novo": ela pode ter mudado de estado entre o turno que
   * falhou e este clique. Reusa o par `iniciarFalaProgressiva`/
   * `finalizarFalaProgressiva` (ADR-017-02) — sem isso, `modo_voz` até
   * viajava no corpo (`_ultimoEnvio` já carregava o valor do turno original),
   * mas ninguém armava `_aceitandoDeltas`: a resposta do reenvio chegava
   * muda e o `_aoFilaEsvaziar` nunca disparava por este caminho.
   *
   * @returns {Promise<?Object>} o `responseData` do reenvio, ou `null`.
   */
  /**
   * [spec-013 T024] Registra um envio de ATALHO como o último desta instância
   * — e, junto, QUEM sabe repeti-lo.
   *
   * Dois motivos para existir:
   *
   * 1. **A bolha de erro oferece o reenvio por `Boolean(this._ultimoEnvio)`**
   *    (`_registrarTurnoComErro`). Sem este registro, o `/panorama` que morre
   *    no meio ou não oferece botão nenhum, ou — pior, o que acontecia —
   *    oferece um que reenvia a última fala de TEXTO da conversa.
   * 2. **Sem import circular.** `apiChat` não pode importar `apiChatAtalhos`
   *    (que importa `apiChat`): o ciclo é o mesmo que derrubou 8 suítes em
   *    26/08 (ver `utils/contexto-de-execucao.js`). Por isso o despachante é
   *    REGISTRADO por quem envia — molde de `setContextoDeTelaProvider`/
   *    `registrarExecutorDeAcao`. Só há envio de atalho guardado aqui se o
   *    módulo que sabe despachá-lo já rodou, então o par nunca fica meio.
   *
   * @param {Object}    envio                  `{slug, label, argumento, conversationId}`.
   * @param {Function=} despachante            `({slug, label, argumento, conversationId}) => Promise`.
   */
  registrarEnvioDeAtalho({ slug, label, argumento, conversationId } = {}, despachante) {
    this._ultimoEnvio = {
      tipo: TIPO_ENVIO_ATALHO,
      slug: slug,
      label: label || '',
      argumento: argumento || null,
      conversationId: conversationId || null,
    }
    if (typeof despachante === 'function') this._despachanteDeAtalho = despachante
  }

  /**
   * O reenvio de um ATALHO — pelo MESMO transporte do envio original
   * (`apiChatAtalhos.sendAtalho`, corpo com `comando`), nunca por
   * `sendMessage`: o contrato do turno de atalho RECUSA `query` preenchida
   * junto de `comando` (`contratos/entrada.py::_validar_forma_de_entrada`), e
   * o que a `query` levaria é a pergunta de texto anterior.
   *
   * Sem Modo de Voz aqui, de propósito: o envio original do atalho também não
   * passa por `iniciarFalaProgressiva` — o turno de atalho não roda modelo e
   * não emite `fala` (`core/atalhos/turno.py`: "Zero token, zero real").
   * Armar a fala progressiva no reenvio prometeria um áudio que nunca chega.
   */
  _reenviarAtalho(envio, conversationId) {
    if (typeof this._despachanteDeAtalho !== 'function') {
      console.warn('[IA CRM] atalho a reenviar sem despachante registrado: nada reenviado.')
      return null
    }
    return this._despachanteDeAtalho({
      slug: envio.slug,
      label: envio.label,
      argumento: envio.argumento,
      conversationId: conversationId,
      // O reenvio sai por ESTA instância — com conversa viva, o singleton
      // escreveria no namespace que a tela não lê (ver `apiChatAtalhos`).
      motor: this,
    })
  }

  async reenviarUltimoTurno() {
    const envio = this._ultimoEnvio
    if (!envio) {
      console.warn('[IA CRM] nada a reenviar: nenhum envio anterior nesta instância.')
      return null
    }
    const getters = store.getters || {}
    const conversa = getters[this.storeNamespace + '/selectedConversation']
    const conversationId = (conversa && conversa.id) || envio.conversationId || null
    // [spec-013 T024] O que morreu foi um ATALHO: repetir pelo `sendMessage`
    // mandaria `query` com o último texto digitado — o consultor pediu
    // `/panorama` e receberia de volta a pergunta anterior, já respondida.
    if (envio.tipo === TIPO_ENVIO_ATALHO) return this._reenviarAtalho(envio, conversationId)
    const vozAtiva = motorDeVoz.sessaoDeVozAtiva
    const geracao = vozAtiva ? iniciarFalaProgressiva(this._vozSelecionadaAtual()) : null
    try {
      return await this.sendMessage({
        ...envio,
        modoVoz: vozAtiva,
        conversationId: conversationId,
      })
    } finally {
      if (vozAtiva) finalizarFalaProgressiva(geracao)
    }
  }

  _processEvent(eventType, dataString, handlers) {
    try {
      const normalizado = normalizarEnvelopeDeEvento(JSON.parse(dataString))
      if (normalizado.idRun) this._runAtualIdRun = normalizado.idRun
      if (this._descartarFrameRepetido(eventType, normalizado)) return
      this._atualizarFase(eventType)
      // Só chaves PRÓPRIAS: um evento chamado `constructor`/`toString` cairia
      // em `Object.prototype` e não é handler.
      const handler = Object.prototype.hasOwnProperty.call(handlers, eventType)
        ? handlers[eventType]
        : null
      if (handler) handler(normalizado.payload)
      if (eventType !== EVENTO_ISENTO_DO_DEDUPE) {
        this._marcarFrameAplicado(normalizado.seq, normalizado.frameIndex)
      }
      this._avancarCursorSeNecessario(normalizado)
    } catch (err) {
      console.warn('[IA CRM] Erro ao processar evento SSE:', err, dataString)
    }
  }

  /**
   * ★ merge PR #2242 — o desembrulho do ENVELOPE do Modo Agente (spec-002)
   * voltou para cá junto com o dedupe e o cursor.
   *
   * O relay agêntico não manda o payload direto: manda
   * `{event_type, seq, id_run, data, frame_index?, frame_count?}`
   * (`contracts/internal-api.md` §5). Isso vivia no `_processEvent` do
   * `apiChatStream.js`, o mixin que o merge deixou de aplicar — sem ele os
   * handlers recebiam o ENVELOPE no lugar do payload e liam `undefined` em
   * cada campo, sem erro nenhum: `estado` virava `null`, o plano nunca
   * chegava, o cursor não avançava e o replay duplicava frame.
   *
   * `normalizarEnvelopeDeEvento` degrada sozinha no Modo Chat (sem envelope,
   * `payload` é o próprio JSON e `seq` é `null`) — então dedupe e cursor viram
   * no-op ali, e o caminho de `desenvolvimento` não muda.
   *
   * `true` quando o frame já foi aplicado nesta instância. `error` é ISENTO
   * (C-87C): ele chega com `seq` FIXO `=1`, que não é cursor real — numa
   * reconexão com watermark já avançado o dedupe o descartaria e NENHUM
   * handler de erro rodaria (`chatLoading` preso, backoff gasto à toa);
   * e marcá-lo REGREDIRIA o watermark, fazendo o replay seguinte reaplicar
   * tudo que já rodou.
   */
  _descartarFrameRepetido(eventType, normalizado) {
    if (eventType === EVENTO_ISENTO_DO_DEDUPE) return false
    if (!this._frameJaAplicado(normalizado.seq, normalizado.frameIndex)) return false
    // O cursor ainda tenta avançar (idempotente): é o que deixa o OUTRO frame
    // do mesmo grupo — o que nunca rodou — completar o grupo.
    this._avancarCursorSeNecessario(normalizado)
    return true
  }

  /**
   * ★ O frame em montagem vive no estado da INSTÂNCIA, não em variável local.
   *
   * Esta função roda uma vez por CHUNK da rede, e a rede corta em qualquer byte
   * — inclusive entre a linha `event:` e a linha `data:` do MESMO frame. Com
   * estado local, o `event:` do chunk N era descartado (o `if` do fim não
   * dispara sem `data`) e o chunk N+1 recomeçava vazio: o evento sumia em
   * silêncio, sem erro e sem log. Quando o corte caía no `end`, o que sumia era
   * a resposta inteira do turno — a bolha do assistente nunca chegava à thread.
   *
   * Pelo mesmo motivo o flush acontece SÓ na linha em branco, que é o
   * delimitador de frame do protocolo, e uma última vez no fim do stream
   * (`_drainReader`): o fim do chunk não tem relação nenhuma com a fronteira do
   * frame.
   *
   * Medido em 26/08/2026 nos dois casos de `★ frame cortado entre chunks` do
   * `.unit.js` (spec-001 do `project-plataforma-por-chat`, [T018]). O conserto
   * existia no parser próprio do ai-framework; ao unificar os parsers ele subiu
   * para cá, onde vale para as quatro superfícies.
   */
  _processStreamLines(lines, handlers) {
    for (const line of lines) {
      if (!line.trim()) {
        this._flushFrame(handlers)
        continue
      }
      if (line.startsWith('event: ')) {
        this._frameEvento = line.substring(7).trim()
      } else if (line.startsWith('data: ')) {
        this._frameData = line.substring(6).trim()
      }
    }
  }

  /**
   * Entrega o frame montado e zera o acumulador.
   *
   * Frame sem `event:` ou sem `data:` é descartado — é o que sobra de um `data:`
   * órfão ou de um `event:` que o stream fechou antes de completar.
   */
  _flushFrame(handlers) {
    const evento = this._frameEvento
    const dados = this._frameData
    this._frameEvento = ''
    this._frameData = ''
    if (!evento || !dados) return
    this._processEvent(evento, dados, handlers)
  }

  _consumeStreamBuffer(buffer, handlers) {
    const lines = []
    let remaining = buffer
    let line
    while ((line = getLineFromBuffer(remaining)) !== null) {
      remaining = remaining.substring(line.length + 1)
      lines.push(line)
    }
    this._processStreamLines(lines, handlers)
    return remaining
  }

  /**
   * O `fetch` deste turno foi abortado?
   *
   * ⚠️ Serve para o laço de leitura sair no meio (`_drainReader`), enquanto o
   * controller ainda existe. NÃO serve no `catch` do `_executeStream`: lá o
   * `cancelRequest` já zerou o controller, e é a marca `_cancelamentoPedido`
   * que responde por lá.
   */
  _isAborted() {
    return Boolean(this.abortController && this.abortController.signal.aborted)
  }

  async _drainReader(reader, handlers, ehAtivo = () => true) {
    const decoder = new TextDecoder()
    let buffer = ''
    while (true) {
      // Stream SUBSTITUÍDO (`_abrirAbortController` de um turno novo) sai pela
      // mesma porta do aborto: nenhum byte dele chega mais aos handlers.
      if (this._isAborted() || !ehAtivo()) {
        await this._cancelarReader(reader)
        return
      }
      const result = await reader.read()
      if (result.done) break
      if (!ehAtivo()) return
      buffer += decoder.decode(result.value, { stream: true })
      buffer = this._consumeStreamBuffer(buffer, handlers)
    }
    if (!ehAtivo()) return
    // Fim do stream: o backend fecha a conexão logo depois do último `data:`,
    // sem a linha em branco terminadora. Fora do laço de propósito — o retorno
    // por ABORT acima não passa por aqui: turno cancelado não emite meio frame.
    this._flushFrame(handlers)
  }

  async _cancelarReader(reader) {
    try { await reader.cancel() } catch (e) { /* reader pode já estar fechado */ }
  }

  _streamAtivo(seq) {
    return seq === this._streamSeq
  }

  async flowRequestMessage(response) {
    const meuStream = this._streamSeq
    const reader = response.body.getReader()
    this.activeReader = reader
    const leitura = this._drainReader(reader, getEventHandlers(this), () => this._streamAtivo(meuStream))
    this._streamEmVoo = leitura
    try {
      await leitura
    } finally {
      // Só o dono solta os handles: o stream novo pode já ter posto os dele.
      if (this.activeReader === reader) this.activeReader = null
      if (this._streamEmVoo === leitura) this._streamEmVoo = null
    }
  }

  /**
   * Espera a leitura ATIVA terminar (sem propagar o erro dela — quem a abriu
   * já o trata). É o que a continuação de uma tool de front faz antes de abrir
   * o próprio stream ([T024]): o handler roda em microtasks a partir do
   * `tool-input-available`, ANTES de o `end` do primeiro stream chegar da
   * rede — abrir a continuação nessa janela abortaria o primeiro stream e a
   * mensagem dele nunca passaria pelo `_onEventEnd`.
   */
  async _aguardarStreamEmVoo() {
    const emVoo = this._streamEmVoo
    if (!emVoo) return
    try { await emVoo } catch (e) { /* desfecho é de quem abriu o stream */ }
  }

  /**
   * A rota do turno — sempre a porta única do motor.
   *
   * ★ [spec-010 T030] Até aqui escolhia entre DUAS rotas dedicadas por
   * `persona` (Consultor Estratégico / Especialista Fee-Based). Removidas: a
   * instância que precisar de um `endpoints.chat` próprio (nenhuma precisa
   * mais, mas o mecanismo de override do construtor continua existindo para
   * outras rotas de sessão) o mantém; na default,
   * `this.endpoints.chat === intelligenceV2.chat`.
   */
  _endpointDoChat() {
    return this.endpoints.chat
  }

  _buildChatBody({ message, displayMessage, conversationId, answerStyle, model, thinkingEnabled, origemModulo, idClienteApp, agenteSolicitado, anexos, modoVoz, camposConfirmados, toolCallIdDoCartao, comando }) {
    const body = {
      query: message,
      conversation_id: conversationId || null,
      answer_style: answerStyle || 'direto',
      thinking_enabled: thinkingEnabled !== false,
    }
    if (model) body.model = model
    // Os TRÊS campos opcionais do corpo, num `Object.assign` só: as chaves são
    // disjuntas, a ordem de aplicação é a mesma de quando eram três chamadas, e
    // o método já está no teto de statements do repo (extrair/fundir é a regra
    // daqui, nunca desabilitar a regra).
    //
    // - `_campoComando` — o atalho de negócio da home-ia (`/panorama`,
    //   `/pré-reunião <cliente>`): a TERCEIRA forma de entrada do turno, ao lado
    //   de `query`/`tool_output`. Só entra quando há atalho de verdade.
    // - `_campoModoVoz` [voz v3, 08/09] — sinaliza que o turno nasceu do Modo de
    //   Voz: liga a versão FALADA curta (evento SSE `fala`) e o STT com o
    //   vocabulário do servidor. Só entra quando `true`.
    // - `_campoCliqueNoCartao` [spec-008, 17/09] — o id do cartão CLICADO.
    //   `modo_voz` marca a SESSÃO; este diz que, DENTRO dela, foi o dedo e não o
    //   microfone. Só entra quando há um id.
    //
    // Os três seguem a MESMA regra: ausentes por default, para o corpo de toda
    // mensagem digitada seguir byte a byte o de hoje.
    Object.assign(
      body,
      _campoComando(comando),
      _campoModoVoz(modoVoz),
      _campoCliqueNoCartao(toolCallIdDoCartao)
    )
    // ★ [spec-021, T004] Os campos que o consultor EDITOU no cartão de
    // confirmação, `{ campo: valor }`. Canal PRÓPRIO, ao lado da mensagem —
    // que continua sendo a autorização (o protocolo com o modelo não muda).
    // Medido na teste 9: o owner corrigiu o e-mail do destinatário no cartão,
    // confirmou, e o envio usou o do cadastro — porque o valor digitado não
    // tinha por onde viajar. Só entra quando há algo editado, para o corpo de
    // toda confirmação que não edita nada seguir byte a byte o de hoje.
    if (camposConfirmados && Object.keys(camposConfirmados).length) {
      body.campos_confirmados = camposConfirmados
    }
    // ★ [F-10, review front spec-015 it.1 — fecha o T033] `persona` nunca
    // viajou no corpo (`resource_chat.py`/[T018] a ignorava; a rota também
    // não variava por ela desde [T030], ver `_endpointDoChat`) — o parâmetro
    // sobrevivia na ASSINATURA por compatibilidade de chamadores que já não
    // existem mais. Removido daqui, de `sendMessage`/`sendToolOutput` e dos
    // 2 call-sites de `view-chat.vue`.
    // Superfície de onde o usuário falou — eixo ortogonal à persona. Mesma regra: só entra
    // quando informada, para que o corpo do IA Operacional siga byte a byte o de hoje. O
    // backend valida contra allow-list, então valor inesperado vira a default lá.
    if (origemModulo) body.origem_modulo = origemModulo
    // Agente ESCOLHIDO PELO USUÁRIO na sidebar/palette/composer (pedido do
    // owner, 06/09/2026: "podemos direcionar a conversa para um agente
    // específico... se o usuário for explícito"). Eixo PRÓPRIO, diferente de
    // `persona` (linhas acima — aceita e ignorada) e de `origem_modulo`
    // (define a SUPERFÍCIE, não o agente): `agente_solicitado` é o nome que o
    // `reqparse` do `resource_chat.py` registra (contrato fechado com o dev de
    // backend — `nos_declaracao_explicita`/`EntradaDeTurno.agente_solicitado`).
    // "Solicitado", não "determinado": o backend valida elegibilidade (guard
    // 2, `agente_pedido_e_valido`) e pode RECUSAR em silêncio, caindo no
    // roteador normal — nunca vira erro. Mesma regra dos outros dois: SÓ entra
    // quando o chamador teve uma escolha de verdade para relatar —
    // `view-chat.vue::irParaAgente` é o único produtor (clique explícito),
    // nunca o agente ativo por default; e só quando o item escolhido É um
    // agente do catálogo (`getAgente(id).agentSlug`, ver `constants/
    // Agentes.js::agentSlugRequisitavel`) — mandar um valor de outro
    // vocabulário (ex.: `painel`, que é um MODO, não um agente) só inflaria o
    // corpo com uma recusa garantida.
    //
    // ⚠️ Só na CRIAÇÃO (`conversationId` ausente): uma conversa que já existe
    // tem o agente que a criou — resend não re-vincula (mesmo eixo do
    // `idClienteApp`). Sem este guard, `reenviarUltimoTurno` repetiria
    // `agente_solicitado` de `_ultimoEnvio` mesmo depois de o backend ter
    // criado a conversa (comentário de `reenviarUltimoTurno` abaixo: o turno
    // pode morrer DEPOIS de a conversa nascer, e o retry já mira o id novo).
    if (agenteSolicitado && !conversationId) body.agente_solicitado = agenteSolicitado
    // Cliente-alvo da conversa (spec-005 do project-onboarding-with-ai-fee-fixo).
    // Mesma regra dos dois acima — só entra quando informado, para o corpo do IA
    // Operacional seguir byte a byte o de hoje.
    //
    // ⚠️ [19/09/2026] Este bloco AFIRMAVA que o backend usa o campo em UM eixo
    // só (a criação da conversa) e que o SEGUNDO eixo "não existe neste
    // checkout". As duas frases estão erradas hoje — medido no backend:
    //
    // 1. `self._id_cliente_app` tem TRÊS leitores, não um: o payload do INSERT
    //    (`usecase_ia_crm_chat.py:1796`), o prefixo de memória do turno
    //    (`:4280`) e o executor de tools (`:4617`), que o injeta em cada tool
    //    por `setattr` (`core/supervisor/executor.py:674` — o MESMO executor
    //    nos dois caminhos, legado e supervisor, desde a spec-010 [T011]).
    // 2. O segundo eixo existe, pelo IRMÃO `id_cliente`: ele monta o bloco de
    //    escopo do system prompt (`:4244`) e vira `id_cliente_escopo` no
    //    executor (`:4621`). O resource entrega o MESMO valor aos dois
    //    (`resource_chat.py:850` e `:934`), e a docstring de
    //    `_resolver_cliente` diz isso desde 26/08 ("o valor que sai daqui vai
    //    para os DOIS eixos").
    //
    // Ou seja: o campo não é só organização de tela — ele decide o que o
    // modelo sabe e o que as tools recebem. E vale em TODO turno, não só na
    // criação: quem chama passa `idClienteEmFoco` em cada `sendMessage`
    // (`view-chat.vue`), e o guard abaixo é truthiness, não `!conversationId`.
    //
    // O que já era verdade e continua: o valor passa pelo RBAC lá
    // (`_resolver_cliente` → `APIPermissoes`) — cliente fora da visão do
    // profissional vira `None` com log, e o turno segue.
    if (idClienteApp) body.id_cliente_app = idClienteApp
    // Anexos do composer JÁ enviados ao servidor (spec-016 T023 — fecha o gap
    // G3/G-4: `importar_carteira_fee_fixo` sem `upload_id`). Mesma régua dos
    // três campos acima: só entra quando há pelo menos um upload concluído,
    // para o corpo do IA Operacional seguir byte a byte o de hoje quando
    // ninguém anexa nada.
    //
    // ⚠️ Isto NÃO é `anexosParaExibir` (o `File[]` cru que só alimenta a
    // bolha do usuário, em `sendMessage`/`addMessage` abaixo). São dois
    // parâmetros DIFERENTES por desenho: `File` não serializa em JSON, e
    // mandá-lo aqui quebraria o POST inteiro silenciosamente (o browser
    // stringifica pra `"[object File]"`). O nome de cada chave é snake_case
    // porque é o que o `reqparse` do `resource_chat.py` registra — mesmo
    // cuidado do `id_cliente_app`/`display_message` acima.
    // ★ [#28] A conversão mora em `utils/anexos-para-o-corpo` — o Modo Agente
    // usa a MESMA. Duas cópias divergiriam no primeiro campo novo, e o
    // sintoma seria a IA dizendo "não recebi nenhum arquivo" só num dos modos.
    const anexosDoCorpo = anexosParaOCorpo(anexos)
    if (anexosDoCorpo.length) body.anexos = anexosDoCorpo
    // O que o USUÁRIO escreveu, quando difere do que o modelo lê (G-Q1). A
    // `query` do Fee Fixo começa pelo bloco de contexto, e o backend deriva o
    // `topic` da conversa dos primeiros caracteres do que recebe — o rótulo da
    // lateral nunca alcançava a pergunta dele. Mesma regra da persona e do
    // `origem_modulo`: só entra quando informado, para o corpo do IA
    // Operacional seguir byte a byte o de hoje.
    if (displayMessage) body.display_message = displayMessage
    // Contexto de tela (US-5) — SEMPRE presente, ao contrário da persona e da
    // origem. A spec pede que toda mensagem carregue a tela aberta: é o que faz
    // "a carteira desse cliente" resolver sem repetir o nome. Seguro antes do
    // T012 subir: o `reqparse` do backend descarta argumento não registrado.
    Object.assign(body, this._contextoDeTela())
    return body
  }

  // `meuStream` OBRIGATÓRIO: o número vem de quem reivindicou o stream
  // (`_abrirAbortController`) — reler `this._streamSeq` aqui seria a leitura
  // tardia que a review do #2284 condenou.
  async _executeStream(response, meuStream) {
    try {
      await this.flowRequestMessage(response)
      if (!this._streamAtivo(meuStream)) return respostaDeCancelamento()
      this._flushTokenBuffer()
      // ★ N-1 (STRESS r2) — `setChatLoading(false)` NÃO roda mais aqui
      // incondicionalmente. O fecho anômalo (abaixo) pode ser o PROXY, não o
      // TURNO — uma tool longa no servidor passa segundos sem emitir byte
      // nenhum, e derrubar o loading agora libera o composer por alguns
      // instantes ANTES de sabermos se o backend ainda está processando: a
      // janela em que o clique de Enviar sumia em silêncio. O desfecho
      // NORMAL (`end`) e o `error` do servidor já derrubam o loading dentro
      // do próprio handler (`_onEventEnd`/`_onEventError`); o caminho feliz
      // repete o dispatch mais abaixo (idempotente, sem flicker novo).
    } catch (err) {
      // ★ [15/09/2026] Stream SUBSTITUÍDO por um turno novo: o desfecho dele não
      // toca na store — `_encerrarTurnoCancelado` derrubaria o `chatLoading` do
      // stream que acabou de começar (a corrida que segurou o item 3 da análise
      // da troca de conversa).
      if (!this._streamAtivo(meuStream)) return respostaDeCancelamento()
      return this._desfechoDoErroDeLeitura(err)
    }
    this._avisarQueOSaldoMudou()
    // ★ merge PR #2242 — [adv C-30] no Modo Agente o EOF sem `end`/`error` NÃO
    // encerra o acompanhamento: o relay pode ter caído com o run vivo. Vem
    // ANTES do fecho anômalo de `desenvolvimento` (que consulta
    // `GET /chat/status`, por CONVERSA) porque aqui há cursor — a reconexão
    // certa é `GET /runs/{id}/eventos?desde=`, e ela religa o `chatLoading`.
    if (this._reconectarPorEofSeRunAberto()) return this.responseData || {}
    if (this._fechouSemDesfecho()) return this._recuperarOuEncerrarSemDesfecho()
    store.dispatch(this.storeNamespace + '/setChatLoading', false)
    return this.responseData || {}
  }

  /**
   * ★ merge PR #2242 — [adv C-39] o `end` do relay agêntico carrega
   * `id_conversa` em campo PRÓPRIO (não dentro de `value`), e é ele que mantém
   * o fallback de reconexão por conversa atualizado quando o `start` não veio
   * (um replay por cursor entra no meio do run, sem `start`).
   *
   * Método próprio pela complexidade do `_onEventEnd`, que já está no teto.
   */
  _fixarConversaDoEnd(data) {
    const idConversa = data && data.id_conversa
    if (idConversa) this._conversationIdAtual = idConversa
  }

  /**
   * ★ merge PR #2242 — a reconexão disparada pelo `error` do servidor.
   *
   * Método próprio pelo teto de statements do repo. `data.id` é o uuid da
   * CONVERSA (`events.json`), e o replay legado é por conversa; com um run
   * agêntico em voo (spec-002) a reconexão certa é por CURSOR
   * (`GET /runs/{id}/eventos?desde=`) — o replay por conversa perderia o log
   * do run e o cursor que esta instância já aplicou.
   *
   * @returns {boolean} `true` quando reconectou (o chamador não segue adiante).
   */
  _reconectarPeloErroDoServidor(data) {
    if (!data.id || this.reconnectCalled) return false
    this.reconnectCalled = true
    if (this._runAtualIdRun) {
      this.reconectarPorCursor(this._runAtualIdRun, this._runAtualSeq)
      return true
    }
    this.reconnect({ id: data.id })
    return true
  }

  /**
   * ★ merge PR #2242 — o laço de reconexão por cursor do Modo Agente (spec-002),
   * que vivia no `_executeStream` do `apiChatStream.js` (o mixin que o merge
   * deixou de aplicar). Fire-and-forget: não atrasa o retorno do turno.
   *
   * Só vale com run conhecido (`_runAtualIdRun`, do `start`/`aceitarRun`) — o
   * Modo Chat não tem cursor para reconectar e segue pelo caminho de
   * `desenvolvimento`. `_reconexaoEofEmAndamento` é o guard de reentrância
   * [VERIFY-1/M-5]: um relay que cai repetidamente multiplicaria laços
   * concorrentes, um por nível de profundidade.
   *
   * @returns {boolean} `true` quando agendou (o chamador não segue adiante).
   */
  _reconectarPorEofSeRunAberto() {
    if (this._drenandoRunTerminal) return false
    if (this._terminalRecebido) return false
    if (this._isAborted()) return false
    if (!this._runAtualIdRun) return false
    if (this._reconexaoEofEmAndamento) return false
    this._agendarReconexaoPorEof()
    return true
  }

  /**
   * O `catch` de `_executeStream` (extraído só pelo `max-statements`): o aborto
   * que NÓS pedimos ([T024]) chega como exceção de leitura (`BodyStreamBuffer
   * was aborted`) — tratá-lo como queda de conexão fazia a superfície avisar
   * "a conversa não foi salva" sobre um turno que o servidor recebeu inteiro
   * (achado 2 do E2E do [T023]). O resto é a queda de conexão de verdade.
   */
  _desfechoDoErroDeLeitura(err) {
    if (this._foiCancelamentoDeliberado(err)) return this._encerrarTurnoCancelado()
    console.error('[IA CRM] Erro durante leitura do stream:', err)
    this._encerrarStreamComErro()
    store.dispatch(this.storeNamespace + '/resetToolCalls')
    // ★ merge PR #2242 — queda REAL de rede não produz o evento SSE `error`
    // (Q-7): sem isto, no Modo Agente o consultor ficava sem sinal nenhum —
    // nem chip, nem o banner `reconectando` que o EOF-sem-terminal já liga.
    if (this._reconectarPorEofSeRunAberto()) {
      return this.buildErrorResponse({ message: COPY_QUEDA_DE_CONEXAO })
    }
    this._desfechoDaQuedaDeConexao()
    return this.buildErrorResponse({ message: COPY_QUEDA_DE_CONEXAO })
  }

  /**
   * O desfecho de uma queda de conexão no meio do stream: a bolha, a voz e o
   * saldo. Vive fora do `catch` de `_executeStream` só para ele caber no
   * `max-statements` — a ordem das três chamadas é a mesma de antes.
   */
  _desfechoDaQuedaDeConexao() {
    // A queda de conexão mata o turno tanto quanto o `error` do servidor — e
    // é a que mais confunde, porque não vem com explicação nenhuma.
    this._registrarTurnoComErro(COPY_QUEDA_DE_CONEXAO)
    // [G-2 SHOULD, review spec-019, 10/09] Este ramo já monta a bolha —
    // faltava FALAR. `_falarDesfechoDeErro` reusa a MESMA régua do T004
    // (`_onEventError`): recusa sozinha se foi cancelamento deliberado ou
    // se a sessão de voz não está ativa, então é seguro chamar aqui sem
    // reimplementar a guarda.
    this._falarDesfechoDeErro(COPY_QUEDA_DE_CONEXAO)
    // ★ O saldo é relido AQUI TAMBÉM. Quem cai depois do `end` perdeu o fio, não a
    // cobrança: o servidor recebeu o turno inteiro e debitou (o débito acontece
    // depois do `yield` do `end`). Sair sem avisar deixava o rodapé exibindo o saldo
    // anterior até um F5 — um número que se lê como atual e já não é. A exclusão
    // continua sendo só o cancelamento deliberado, tratado no `return` do `catch`.
    this._avisarQueOSaldoMudou()
  }

  /**
   * O stream fechou sem `end`/`error` — mas pode ser o PROXY, não o TURNO
   * (N-1, STRESS r2, medido com `ler_extrato`: tool de ~45s no servidor,
   * `chatLoading` caindo em ~9s de silêncio na rede). Antes de declarar o
   * turno morto, pergunta ao backend pelo `GET /chat/status` — só quando ele
   * confirma que NÃO há nada em voo (ou a própria reconexão também fechar
   * sem desfecho) é que o composer é liberado de verdade. Enquanto a checagem
   * dura, `chatLoading` segue `true` (nunca foi derrubado — ver
   * `_executeStream`): um clique de Enviar nessa janela cai no guard normal
   * do composer, não no vácuo.
   *
   * NÃO reusa `recoverQuestion` — o contrato dele (US pública, superfície
   * externa) é devolver o envelope do `status`, e aqui o que importa é o
   * DESFECHO do turno depois de reconectar. Consultar `con.get` direto evita
   * ambiguidade entre "não reconectou" e "reconectou e falhou de novo".
   *
   * Sem `conversationId` (a conexão caiu antes do `start` chegar — turno
   * ainda sem id) não há o que consultar: mesmo fecho anômalo de sempre. E
   * `reconnectCalled` já `true` (um `error` do servidor reconectou antes, e
   * ESSA reconexão que fechou sem desfecho) não tenta de novo — mesma trava
   * de sempre contra loop de reconexão.
   */
  async _recuperarOuEncerrarSemDesfecho() {
    const conversationId = this._conversaAtual()
    if (!conversationId || this.reconnectCalled) {
      return this._encerrarTurnoSemDesfecho()
    }
    // ★ [17/09/2026] Canal sem rota de status (o agent-chat declara
    // `chatStatus: null`) não tem a quem perguntar se o servidor ainda
    // processa — o vestígio no thread é o desfecho, e chamar `chatStatus(id)`
    // aqui seria um TypeError em cima de um turno que já morreu.
    if (typeof this.endpoints.chatStatus !== 'function') {
      return this._encerrarTurnoSemDesfecho()
    }
    const status = await con.get(this.endpoints.chatStatus(conversationId))
    const aindaProcessando = Boolean(
      status && status.status === 200 && status.value && status.value.status === 'processing'
    )
    if (!aindaProcessando) {
      return this._encerrarTurnoSemDesfecho()
    }
    this.reconnectCalled = true
    return this.reconnect({ id: conversationId })
  }

  /**
   * O turno acabou de sair do fio — quem mostra saldo pode reler.
   *
   * ★ **O sinal é o FECHO DO STREAM, nunca o evento `end`, e a diferença é uma
   * corrida real.** O backend debita DEPOIS do `yield` do `end`
   * (`usecase_ia_crm_chat.py`, nos DOIS miolos: legado e Supervisor), porque só
   * com o run fechado os tokens são finais — antes disso, debitar seria
   * estimar. Recarregar no handler do `end` leria o saldo ANTERIOR, e daria um
   * número que às vezes acerta: bug intermitente, o pior tipo.
   *
   * Aqui não há timer nem tentativa: quando `flowRequestMessage` resolve, o
   * `reader` recebeu `done`, e `done` só chega depois de o servidor EXAURIR o
   * gerador — que é exatamente onde o débito roda. A ordem é garantida pelo
   * protocolo do gerador, não por espera.
   *
   * ⚠️ **Uma vez por STREAM**, e não por evento: o `end` é um entre muitos
   * (`text-delta`, `tool-*`), e reler a cada um seria N+1 por resposta. Uma
   * continuação de tool de front é um POST novo — logo um turno novo para o
   * servidor, com débito próprio — e por isso avisa de novo, corretamente.
   *
   * Cancelamento deliberado não avisa: o gerador do servidor morre no `yield`
   * seguinte e o débito daquele turno não chega a rodar, então não há nada de
   * novo para ler.
   *
   * O canal é o `RELOAD` global de propósito — o motor do chat não conhece a
   * carteira, e o rodapé de saldo mora noutro módulo (`ai-framework`).
   */
  _avisarQueOSaldoMudou() {
    if (this._cancelamentoPedido === true) return
    GlobalBus.$emit(RELOAD.CREDITOS_SALDO)
  }

  /**
   * O stream acabou e NINGUÉM disse como o turno terminou ([G-2 do QA]).
   *
   * O fio fecha sem exceção — a leitura simplesmente chega ao fim —, então
   * nenhum `catch` pega isto. Só o `end` e o `error` fecham um turno; sem os
   * dois, o que houve foi a resposta parar no meio.
   *
   * ★ **Não é anômalo em dois casos**, e cada um seria uma mentira diferente:
   * o cancelamento que NÓS pedimos (foi decisão do usuário) e a reconexão em
   * voo (o turno pode voltar inteiro — mesma recusa do `_registrarTurnoComErro`).
   */
  _fechouSemDesfecho() {
    if (this._drenandoRunTerminal === true) return false
    if (this._turnoFechadoPeloServidor === true) return false
    if (this._cancelamentoPedido === true) return false
    return this.reconnectCalled !== true
  }

  /**
   * O desfecho do fecho anômalo: o mesmo vestígio de qualquer turno morto.
   *
   * O QA mediu o oposto disto — cartões `[]`, nenhuma bolha de erro, nenhum
   * "tentar de novo" e um snack VAZIO, porque o `{}` que este caminho devolvia
   * não tem `status` e o `if (r.status !== 200)` da superfície nunca dispara.
   * Dentro de uma conversa o pior desfecho não é o erro; é o silêncio (§17 do
   * CLAUDE.md do módulo).
   *
   * ★ **Sem `console.error` de propósito.** O vestígio deste caminho é a BOLHA,
   * que fica no thread e sobrevive à rolagem — mais forte que uma linha de log.
   * E o log teria custo alheio: o `setup.js` transforma `console.error` em falha
   * de teste, e as suítes do parser usam de propósito fixtures sem `end` (o
   * `turnoDeToolDeFront` do `apiChat.unit.js` é uma delas) — cada uma teria de
   * declarar um log que não é sobre o que ela mede.
   */
  _encerrarTurnoSemDesfecho() {
    this._encerrarStreamComErro()
    store.dispatch(this.storeNamespace + '/resetToolCalls')
    this._registrarTurnoComErro(COPY_FECHO_ANOMALO)
    // [G-2 SHOULD, review spec-019, 10/09] Mesma régua do ramo de queda de
    // conexão acima — `_falarDesfechoDeErro` já recusa sozinha nos dois
    // casos que `_fechouSemDesfecho()` (quem chama este método) já filtrou
    // antes de chegar aqui (cancelamento, reconexão em voo).
    this._falarDesfechoDeErro(COPY_FECHO_ANOMALO)
    return this.buildErrorResponse({ message: COPY_FECHO_ANOMALO })
  }

  /**
   * A leitura morreu porque alguém DESISTIU daqui de dentro?
   *
   * Dois sinais, porque nenhum dos dois sozinho cobre o caso: o nome do erro
   * (`AbortError`, o que o `AbortController` produz em todo navegador) e a
   * nossa própria bandeira, para o navegador que resolva embrulhar o aborto em
   * outro tipo de erro.
   */
  _foiCancelamentoDeliberado(err) {
    return ehAborto(err) || this._cancelamentoPedido === true
  }

  /**
   * Fecha o turno CANCELADO — sem log de erro e sem shape de falha.
   *
   * Mesma limpeza do `_encerrarStreamComErro` (a pílula da fase não pode ficar
   * acesa apontando um turno morto), com um desfecho diferente para o
   * chamador: `cancelado: true`, que a superfície usa para NÃO avisar falha.
   */
  _encerrarTurnoCancelado(resposta) {
    this._clearTokenBuffer()
    this._resetarFase()
    store.dispatch(this.storeNamespace + '/setChatLoading', false)
    return resposta || respostaDeCancelamento()
  }

  /**
   * Envia uma mensagem ao backend de chat e processa a resposta SSE.
   *
   * @param {Object}  opts
   * @param {string}  opts.message            Texto enviado ao modelo.
   * @param {string=} opts.displayMessage     Texto exibido na bolha do usuário.
   *   Default = `message`. Existe para chat contextual: o drawer do Fee Fixo
   *   anexa à pergunta a tela e o cliente em foco, e mostrar esse bloco na
   *   conversa só poluiria — o usuário lê o que ele mesmo escreveu. Desde a
   *   G-Q1 ele também VIAJA no corpo (`display_message`): é dele que o backend
   *   deriva o rótulo da conversa, com fallback para a `query`.
   * @param {string=} opts.conversationId     ID da conversa existente (omitido cria nova).
   * @param {string=} opts.answerStyle        `direto` (default) ou outro estilo suportado.
   * @param {string=} opts.model              Override do modelo a ser usado (locked por conversa no backend).
   * @param {boolean=} opts.thinkingEnabled   Se `false`, desabilita reasoning content. Default `true`.
   * @param {number=} opts.idClienteApp       Cliente em foco (`app_clientes.id`). Vincula a conversa E escopa o modelo.
   * @param {string=} opts.agenteSolicitado    Agente ESCOLHIDO PELO USUÁRIO (sidebar/palette/composer) — só quando
   *   houve escolha explícita de verdade (`view-chat.vue::irParaAgente`) E o item escolhido é um agente do
   *   catálogo (`constants/Agentes.js::agentSlugRequisitavel`). Nunca o agente ativo por default.
   * @param {Array=}  opts.anexosParaExibir    `File[]` do composer — SÓ para a bolha do usuário.
   *
   *   ⚠️ NÃO entra no corpo do POST, e isso é deliberado: o backend não tem
   *   campo para arquivo (`resource_chat.py`), então mandá-lo seria inventar um
   *   contrato. Ele vai apenas para a mensagem que o store desenha, e por isso
   *   some num F5 — nada foi persistido. Ver `ANEXOS_LIBERADOS` no front.
   *
   *   O dia em que o envio existir, o campo de REDE nasce em `_buildChatBody`;
   *   este continua sendo o de exibição, e os dois não se confundem.
   * @returns {Promise<Object>}               `responseData` do evento `end` ou shape de erro.
   */
  async sendMessage({ message, displayMessage, conversationId, answerStyle, model, thinkingEnabled, origemModulo, idClienteApp, agenteSolicitado, anexosParaExibir, anexos, modoVoz, camposConfirmados, toolCallIdDoCartao, comando } = {}) {
    this.resetChatState()
    // Depois do reset (que zera o estado do turno) e antes de qualquer await: é
    // este registro que o `reenviarUltimoTurno` repete quando o turno morre.
    // `camposConfirmados` entra junto: sem ele o reenvio de um turno de
    // confirmação gravaria os valores do cadastro em vez dos editados.
    // `comando` [spec-001 preparacao-reuniao, T015] segue o mesmo raciocínio:
    // reenviar um atalho sem ele viraria uma pergunta em texto livre — e o
    // atalho só entra pelo campo estruturado (`preflight.py:181-205`, "não há
    // parsing de texto digitado").
    this._ultimoEnvio = {
      message, displayMessage, conversationId, answerStyle, model,
      thinkingEnabled, origemModulo, idClienteApp, agenteSolicitado, anexos, modoVoz,
      camposConfirmados,
      // ★ [spec-009 T016] Os DOIS anexos do turno viajam no registro, não só
      // o de rede. `anexos` (o `upload_id`) já estava aqui — o corpo do
      // reenvio sempre levou o arquivo —, mas `anexosParaExibir` ficava de
      // fora, e a bolha do reenvio nascia SEM os arquivos que a bolha
      // original mostrava: o mesmo turno, no mesmo fio, aparecendo ora com
      // anexo ora sem. O composer não pode repô-los (a fila dele já esvaziou
      // no envio original, `removerAnexosEnviados`), então ou o registro os
      // guarda, ou eles somem da tela.
      anexosParaExibir,
      // [spec-008] O reenvio de um CLIQUE continua sendo um clique — sem
      // isto, o "Tentar de novo" de uma confirmação feita em Modo de Voz
      // voltaria indistinguível de uma fala e seria recusado pela guarda de
      // origem, que é o defeito que o campo existe para fechar.
      toolCallIdDoCartao,
      comando,
    }
    store.dispatch(this.storeNamespace + '/addMessage', {
      id: null,
      role: 'user',
      content: displayMessage || message,
      // Chave ausente quando não há anexo: `[]` faria a bolha renderizar um
      // bloco vazio, e toda mensagem antiga passaria a ter a chave.
      ...(anexosParaExibir && anexosParaExibir.length
        ? { anexos: anexosParaExibir }
        : {}),
    })
    const meuStream = this._abrirAbortController()
    const body = this._buildChatBody({
      message,
      displayMessage,
      conversationId,
      answerStyle,
      model,
      thinkingEnabled,
      origemModulo,
      idClienteApp,
      agenteSolicitado,
      anexos,
      modoVoz,
      camposConfirmados,
      toolCallIdDoCartao,
      comando,
    })

    // (`await` + `return` separados: `require-await` × `no-return-await`.)
    const desfecho = await this._pedirEDrenar(body, meuStream)
    return desfecho
  }

  /**
   * O POST do turno e a drenagem do stream — o miolo comum de `sendMessage` e
   * `sendToolOutput`. `meuStream` é o número devolvido por
   * `_abrirAbortController`: substituído ANTES dos headers (um turno novo
   * abortou este fetch), o envelope de cancelamento que `iaCrmRequest` devolve
   * NÃO passa por `_tratarRespostaNaoStream` — ele derrubaria o `chatLoading`
   * do turno novo.
   */
  async _pedirEDrenar(body, meuStream) {
    const response = await iaCrmRequest({
      method: 'POST',
      endpoint: this._endpointDoChat(),
      body: body,
      customHeaders: STREAM_HEADER,
      options: { signal: this.abortController.signal },
    })
    if (!this._streamAtivo(meuStream)) return respostaDeCancelamento()
    if (!isStreamResponse(response)) {
      return this._tratarRespostaNaoStream(response)
    }
    return this._executeStream(response, meuStream)
  }

  /**
   * Devolve ao modelo o resultado de uma tool executada NO BROWSER (US-4).
   *
   * Vai pelo mesmo `POST /chat`, mas SEM `query`: não é uma fala nova do
   * usuário, é a continuação do turno que parou esperando o browser agir. Por
   * isso não limpa nada — o texto já escrito, as partes já desenhadas e a
   * mensagem do usuário continuam onde estão.
   *
   * ★ **[spec-017 T003] Sobrevive ao Modo de Voz.** Uma tool de front pedida
   * pelo modelo DURANTE um turno de voz (ex.: `abrir_cliente`) fechava o
   * PRIMEIRO stream sem texto (só o `tool_use`), e esta continuação — a
   * resposta de verdade, depois do resultado da tool — nunca levava
   * `modo_voz` nem passava pelo par `iniciarFalaProgressiva`/
   * `finalizarFalaProgressiva`: o servidor não emitia `fala` e o texto
   * escrito chegava com `_aceitandoDeltas` já `false` (fechado pelo
   * `finalizarFalaProgressivaMotor` do PRIMEIRO stream, em `onEnviarVoz`) —
   * a resposta ficava muda. A régua é a mesma do `responderCartao` (ADR-
   * 017-01): `motorDeVoz.sessaoDeVozAtiva` lida agora, e reusa o MESMO par
   * (ADR-017-02) — nenhum re-arme novo.
   *
   * @param {Object}  opts
   * @param {string}  opts.toolCallId     Id do bloco `tool_use` que o modelo abriu.
   * @param {Object=} opts.output         O que aconteceu no browser.
   * @param {string=} opts.conversationId Conversa em curso.
   * @returns {Promise<Object>}
   */
  async sendToolOutput({ toolCallId, output, conversationId } = {}) {
    const vozAtiva = motorDeVoz.sessaoDeVozAtiva
    const geracao = vozAtiva ? iniciarFalaProgressiva(this._vozSelecionadaAtual()) : null
    // O `finally` fecha a pendência declarada em `_marcarContinuacaoDeToolDeFront`
    // em TODOS os caminhos — inclusive na recusa por `toolCallId` ausente, que
    // não chega a sair do browser. Deixá-la aberta faria a view nunca mais
    // descartar um turno em andamento ([T024]).
    try {
      if (!toolCallId) {
        return this.buildErrorResponse({
          message: 'Não foi possível devolver o resultado da ação à IA. Tente novamente.',
          status: 400,
        })
      }
      // O `end` do turno que parou ainda pode estar a caminho — ver
      // `_aguardarStreamEmVoo`. Só depois dele a continuação vira o stream
      // ativo — e o loading é ligado DEPOIS da espera, porque o `end` do
      // primeiro stream o derruba ao passar.
      await this._aguardarStreamEmVoo()
      // O "parar" clicado ENQUANTO a continuação esperava vence: o turno foi
      // cancelado pelo usuário, e devolver o resultado da tool a um run que
      // ele acabou de cancelar religaria o loading sobre nada. (Diferente da
      // troca de conversa/destroy da view, que preservam a continuação.)
      if (this._cancelamentoPedido === true) return respostaDeCancelamento()
      store.dispatch(this.storeNamespace + '/setChatLoading', true)
      this.reconnectCalled = false
      const meuStream = this._abrirAbortController()
      const body = this._payloadSendToolOutput({ toolCallId, output, conversationId, vozAtiva })
      return await this._pedirEDrenar(body, meuStream)
    } finally {
      this._continuacaoDeToolDeFront = false
      if (vozAtiva) finalizarFalaProgressiva(geracao)
    }
  }

  // Extraído de `sendToolOutput` (complexidade ciclomática do ESLint) — só
  // monta o corpo do POST, sem side-effect algum.
  _payloadSendToolOutput({ toolCallId, output, conversationId, vozAtiva }) {
    const body = {
      conversation_id: conversationId || null,
      tool_output: { toolCallId: toolCallId, output: output || {} },
      ..._campoModoVoz(vozAtiva),
    }
    Object.assign(body, this._contextoDeTela())
    return body
  }

  /**
   * Reconecta ao stream SSE de uma conversa em processamento.
   * Acionado automaticamente por `_onEventError` quando o backend devolve `error` com `id`.
   *
   * @param {Object} opts
   * @param {string} opts.id  ID da conversa (mesmo `conversation_id` enviado em sendMessage).
   * @returns {Promise<Object>}
   */
  // O `catch` de `reconnect` (extraído pelo `max-statements`). Aqui o
  // `_onEventError` já tinha deixado passar de propósito (ia reconectar); a
  // reconexão falhou, então o vestígio é responsabilidade deste caminho —
  // senão o turno some sem deixar rastro nenhum.
  _desfechoDaFalhaDeReconexao(err) {
    console.warn('[IA CRM] Erro durante reconexão do stream:', err)
    this._encerrarStreamComErro()
    this._registrarTurnoComErro(COPY_FALHA_DE_RECONEXAO)
    return this.buildErrorResponse({ message: COPY_FALHA_DE_RECONEXAO })
  }

  _pedirReconexao(id) {
    const controller = this.abortController
    return iaCrmRequest({
      method: 'GET',
      endpoint: this.endpoints.chatReconnect(id),
      customHeaders: STREAM_HEADER,
      options: controller ? { signal: controller.signal } : undefined,
    })
  }

  // Envelope (erro/queda) em vez de stream na reconexão: quem chamou pode
  // estar com o loading ligado de propósito (`_recuperarOuEncerrarSemDesfecho`,
  // N-1) — sem derrubá-lo aqui o composer ficava preso até o F5 (review r2).
  _envelopeDaReconexao(response) {
    store.dispatch(this.storeNamespace + '/setChatLoading', false)
    return response || {}
  }

  async reconnect({ id } = {}) {
    // O número é lido ANTES do GET: se um turno novo entrar enquanto a
    // reconexão espera os headers, ela não pode drenar o replay do turno
    // antigo no namespace do novo. O signal é o do controller corrente, para
    // o abort do turno novo derrubar este GET também.
    const meuStream = this._streamSeq
    const response = await this._pedirReconexao(id)
    if (!this._streamAtivo(meuStream)) return respostaDeCancelamento()

    if (!isStreamResponse(response)) return this._envelopeDaReconexao(response)
    store.dispatch(this.storeNamespace + '/setChatLoading', true)

    try {
      await this.flowRequestMessage(response)
      if (!this._streamAtivo(meuStream)) return respostaDeCancelamento()
      this._flushTokenBuffer()
    } catch (err) {
      if (!this._streamAtivo(meuStream)) return respostaDeCancelamento()
      return this._desfechoDaFalhaDeReconexao(err)
    }

    store.dispatch(this.storeNamespace + '/setChatLoading', false)
    return this._desfechoDaReconexao()
  }

  /**
   * O fio da RECONEXÃO cai no mesmo buraco do turno normal ([G-2 do QA]): se
   * ele também acabar sem `end`, o turno recuperado some sem deixar rastro.
   *
   * Aqui o `reconnectCalled` já está true, então a guarda de "reconexão em voo"
   * do `_fechouSemDesfecho` não serve — esta É a reconexão, e ela terminou.
   */
  _desfechoDaReconexao() {
    if (this._turnoFechadoPeloServidor === true) return this.responseData || {}
    if (this._cancelamentoPedido === true) return this.responseData || {}
    return this._encerrarTurnoSemDesfecho()
  }

  /**
   * Verifica se há resposta em processamento para uma conversa e reconecta se houver.
   * Usa `@services/connection` (não SSE) para o status check.
   *
   * @param {Object} opts
   * @param {string} opts.conversationId
   * @returns {Promise<Object>}
   */
  async recoverQuestion({ conversationId } = {}) {
    if (!conversationId) {
      return this.buildErrorResponse({ message: 'conversationId obrigatório', status: 400 })
    }
    const r = await con.get(this.endpoints.chatStatus(conversationId))
    if (r && r.status === 200 && r.value && r.value.status === 'processing') {
      await this.reconnect({ id: conversationId })
    }
    return r || this.buildErrorResponse({ message: 'Erro inesperado' })
  }

  /**
   * Cancela o stream SSE em curso e notifica o backend.
   * Aborta o `fetch`, cancela o `ReadableStreamDefaultReader`, limpa buffer de tokens
   * e dispara `POST /chat/cancel` no backend.
   *
   * @param {Object} opts
   * @param {string} opts.id  ID da conversa a cancelar.
   * @returns {Promise<Object>}
   */
  /**
   * Abre o controlador do stream que vai começar.
   *
   * Zera o `_cancelamentoPedido` junto: a bandeira é do stream ATUAL, e um
   * cancelamento do turno anterior não pode fazer o próximo nascer marcado
   * como cancelado.
   */
  _abrirAbortController() {
    // ★ [15/09/2026] UM stream por instância: o anterior, se ainda aberto, é
    // abortado ANTES da troca de referência (antes ficava órfão e vivo,
    // escrevendo no mesmo namespace da store). O encerramento dele não toca
    // na store porque o número do stream muda aqui — ver `_streamSeq`.
    this._abortarStreamAnterior()
    this._streamSeq += 1
    this._cancelamentoPedido = false
    this.abortController = new AbortController()
    return this._streamSeq
  }

  // Aborta controller + reader do stream corrente sem esperar o `cancel()` do
  // reader (quem espera é o laço dele). Serve à abertura do stream novo e ao
  // botão "parar" (`_abortarStreamAtivo`).
  _abortarStreamAnterior() {
    if (this.abortController) this.abortController.abort()
    const reader = this.activeReader
    if (!reader) return
    this.activeReader = null
    try {
      const pendente = reader.cancel()
      if (pendente && pendente.catch) pendente.catch(() => {})
    } catch (e) { /* reader pode já estar fechado */ }
  }

  _abortarStreamAtivo() {
    // A partir daqui, todo erro de leitura deste stream é consequência do
    // nosso pedido — e não falha do servidor ([T024]).
    this._cancelamentoPedido = true
    this._abortarStreamAnterior()
    this.abortController = null
  }

  async cancelRequest({ id } = {}) {
    this._abortarStreamAtivo()
    // Buffer, fase e `chatLoading` num helper só — é a MESMA limpeza que os
    // catches de leitura fazem, e mantê-la em dois lugares é como eles
    // divergem (o rótulo da fase ficaria aceso apontando um turno morto).
    this._encerrarStreamComErro()
    if (!id) {
      return this.buildErrorResponse({ message: 'id obrigatório', status: 400 })
    }
    const r = await con.post(this.endpoints.chatCancel(id))
    store.dispatch(this.storeNamespace + '/setChatLoading', false)
    return r || this.buildErrorResponse({ message: 'Erro inesperado' })
  }
}

// ★ merge PR #2242 — SÓ os dois mixins do Modo Agente. `apiChatStreamMixin` e
// `apiChatPainelMixin` saíram: os métodos deles colidem com 11 e 7 desta
// classe (`_processEvent`, `_consumeStreamBuffer`, `_flushTokenBuffer`,
// `_maybeCapturePendingConfirmation`…), e como o `Object.assign` roda DEPOIS
// da declaração da classe, ele venceria — trocando, sem um único erro, a
// versão evoluída pelas specs de `desenvolvimento` pela anterior a elas.
// O conteúdo desses dois mixins já vive na classe acima, atualizado.
Object.assign(
  APIChat.prototype,
  apiChatModoAgenteMixin, apiChatModoAgenteEventosMixin
)

export const apiChat = new APIChat()
export { APIChat, TIPO_ENVIO_ATALHO }
